import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import _ from "lodash";
import { FileUpload } from 'primereact/fileupload';
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";
import { Toast } from 'primereact/toast';
import { Tooltip } from "primereact/tooltip";
import { ConfirmDialog } from 'primereact/confirmdialog'

import "./index.css"

import { 
    TextInputField, 
    Button, 
    DropDownField, 
    MultiSelectField, 
    InputSwitchField, 
    AutoCompleteField,
    TextAreaField,
    CalendarField,
    Table
} from "../../../helpers";
import Steps from "../../../helpers/Steps"


import Loading from "../../../common/Loading"
import SACCode from "../../../common/SACCode";
import FileViewAndRemove from "../../../common/FileViewAndRemove";
import AddBillingAddress from "../../../common/AddBillingAddress";

import { getInitialData, insertCompany, uploadFile, verifyGSTINsByPanNumber } from '../../../services/api/company';
import { insertCompanyCertificate } from "../../../services/api/companyCertificates";

import { 
    fetchStates, 
    fetchMaterialCategories, 
    fetchPinCodes, 
    fetchClientSuccessManagers,
    fetchTDSSections,
    fetchApprovals,
    fetchCountries,
    fetchCompanyMSMEDTypes,
    fetchHSNMasterData,
    fetchCompanyTags,
    fetchMaterialBrands
} from "../../../services/redux/reducers/commonThunk";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";

import { checkPermissions, sortArrayOfObjectsInAlphabeticalOrder, combineISDCodeWithPhoneNumber, getUploadedFileObj, getDateString } from "../../../utils";
import { validateInputs, GSTIN_REGEX_FORMAT, SACCodes } from '../../../utils'

import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";
import { companyDetailSchema, initialCompanyDetails } from "../../../validation/addCompanyValidation";

const INITIAL_COMPANY_ROLE = [
    { roleId: uuidv4(), roleName: "HOD" },
    { roleId: uuidv4(), roleName: "BRANCH HEAD" },
    { roleId: uuidv4(), roleName: "REGIONAL HOD" }
]

let newPMBranch = {
    branchId: 0,
    branchName: "All",
    statusId: 1
}

const CompanyAdd = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [visibleAddNewBillingAddr, setVisibleAddNewBillingAddr] = useState(false)

    const [companyRoles, setCompanyRoles] = useState(INITIAL_COMPANY_ROLE)
    const [relatedCompanyGroupTypes, setRealtedCompanyGroupTypes] = useState([])
    const [tdsSection194q, setTdsSection194q] = useState(false);
    const [partialOnboarding, setpartialOnboarding] = useState(false);
    const [isLoaderVisible, setIsLoaderVisible] = useState(true)
    const [isGSTINDataLoading, setIsGSTINDataLoading] = useState(false)
    const [initialData, setInitialData] = useState({})
    const [companyBillAddrs, setCompanyBillAddrs] = useState([])
    const [companyGSTINs, setCompanyGSTINs] = useState([])
    const [companyUsers, setcompanyUsers] = useState([])
    const [companyDetails, setCompanyDetails] = useState(initialCompanyDetails)
    const [isPANVerified, setIsPANVerified] = useState(false)
    const [formErrors, setFormErrors] = useState({})
    const [GSTINs, setGSTINs] = useState([])
    const [prefPMStateList, setPrefPMStateList] = useState([])
    const [searchedClientSuccessManagers, setSearchedClientSuccessManagers] = useState([])
    const [visibleApprovalRemarks, setVisibleApprovalRemarks] = useState(false)
    const [tdsApprovalRemarks, setTDSApprovalRemarks] = useState('')
    const [addCompanyDetails, setAddCompanyDetails] = useState({})
    const [paymentTermsApprovalRemarks, setPaymentTermsApprovalRemarks] = useState('')
    const [companyOnboardingApprovalRemarks, setCompanyOnboardingApprovalRemarks] = useState('')
    const [SACCodesData, setSACCodesData] = useState([])
    const [selectedSACCode, setSelectedSACCode] = useState(null)
    const [visibleSACCode, setVisibleSACCode] = useState(false)
    const [tagOptions, setTagOptions] = useState([])
    const [isConfirmTagDeleteDialogVisible, setIsConfirmTagDeleteDialogVisible] = useState(false)
    const [selectedCompanyTagId, setSelectedCompanyTagId] = useState(null)
    const [visibleAddBrandCertificate, setVisibleAddBrandCertificate] = useState(false)
    const [brandCertificate, setBrandCertificate] = useState({})
    const [brandCertificates, setBrandCertificates] = useState([])
    const [searchedmaterialBrands, setSearchedmaterialBrands] = useState([])

    const pmCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)
    const statesDetails = useSelector((state) => state.common.states)
    const materialCategoriesRedux = useSelector((state) => state.common.materialCategories)
    const userId = useSelector((state) => state.userDetails.userId)
    const userDetails = useSelector((state) => state.userDetails)
    const activeUserRole = userDetails.activeUserRoleDetails
    const pinCodesData = useSelector(state => state.common.pinCodes)
    const clientSuccessManagers = useSelector(state => state.common.clientSuccessManagers)
    const tdsSections = useSelector(state => state.common.tdsSections)
    const approvals = useSelector((state) => state.common.approvals)
    const countriesData = useSelector(state => state.common.countries)
    const companyTags = useSelector(state => state.common.companyTags)
    const materialBrands = useSelector((state) => state.common.materialBrands)
    
    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    const companyMSMEDTypes = useSelector(state => state.common.companyMSMEDTypes)
    const HSNMasterData = useSelector((state) => state.common.HSNMaster)

    const toast1 = useRef(null)
    const gstinDropdownRef = useRef(null)
    const addTagsMenu = useRef(null)

    const tagsConfig = [...companyTags]

    newPMBranch.companyId = pmCompanyDetails.companyId

    const permissionDetails = checkPermissions({...userDetails, userRoleId: userDetails.activeRoleId, permissions: [198]})
    const isIndustryInputPermitted = permissionDetails.isPermitted

    let materialCategories = materialCategoriesRedux.map(eachMaterialCategory => {
        if(eachMaterialCategory.categoryName && eachMaterialCategory.categoryName.toLowerCase() === "bio mass" && !isIndustryInputPermitted){
            return {...eachMaterialCategory, optionDisabled: true}
        }
        return {...eachMaterialCategory}
    })

    let prefPMBranchPermissionDetails = checkPermissions({ ...userDetails, permissions: [213] })
    const prefPMBranches = [{ ...newPMBranch, optionDisabled: !prefPMBranchPermissionDetails.isPermitted }, ...pmCompanyDetails?.companyBranches]

    useEffect(() => {
        getCompanyInitialData()
        dispatch(fetchStates())
        dispatch(fetchPinCodes())
        dispatch(fetchMaterialCategories())
        dispatch(fetchClientSuccessManagers())
        dispatch(fetchTDSSections())
        dispatch(fetchApprovals())
        dispatch(fetchCountries())
        dispatch(fetchCompanyMSMEDTypes())
        dispatch(fetchHSNMasterData())
        dispatch(fetchCompanyTags())
        dispatch(fetchMaterialBrands())
    }, [])

    useEffect(() => {
        if(HSNMasterData?.length > 0){
            let uniqHSNCodes = _.uniqBy(HSNMasterData, "HSNCode")
            
            let relatedHSNCodes = uniqHSNCodes
                .filter(eachHSN => SACCodes.includes(eachHSN.HSNCode))
                .map(eachHSN => ({
                    ...eachHSN,
                    HSNCode: eachHSN.HSNCode.toString()
                }))
            setSACCodesData(relatedHSNCodes)
        }
    },[HSNMasterData])

    useEffect(() => {
        if(companyGSTINs?.length > 0 && gstinDropdownRef.current){
            gstinDropdownRef.current.focus()
        }
    }, [])

    const items = [
        {
            label: 'Company Details'
        },
        {
            label: 'Users'
        },
        {
            label: 'Branch'
        },
        {
            label: 'Bank Accounts'
        },
        {
            label: 'Rate Contract'
        }
    ]

    const getCompanyInitialData = async() => {
        const initailData = await getInitialData()
        if(initailData){
            const initial_data = initailData.data
            console.log("initial_data  ===>", initial_data)

            initailData.data.companyGroupsData = sortArrayOfObjectsInAlphabeticalOrder(initailData.data.companyGroupsData, "groupName")
            initailData.data.companyBusinessTypesData = sortArrayOfObjectsInAlphabeticalOrder(initailData.data.companyBusinessTypesData.filter(eachBusinessType => eachBusinessType.statusId === 1), "businessType")
            initailData.data.companySizeCategoriesData = initailData.data.companySizeCategoriesData.filter(eachSizeCategory => eachSizeCategory.statusId === 1)
            initailData.data.companyTurnoverCategoriesData = initailData.data.companyTurnoverCategoriesData.filter(eachTurnoverCategory => eachTurnoverCategory.statusId === 1)
            initailData.data.companyOwnershipTypesData = sortArrayOfObjectsInAlphabeticalOrder(initailData.data.companyOwnershipTypesData, "ownershipType")

            setInitialData({ ...initial_data })
            setCompanyDetails({ ...companyDetails, hodRole: 'HOD'})
        }
        setIsLoaderVisible(false)
    }

    const handleSubmitCompanyDetails = async () => {
        companyDetails.companyGSTINs = companyGSTINs
        companyDetails.companyRoles = companyRoles
        companyDetails.companyUsers = companyUsers
        companyDetails.companyBillAddrs = companyBillAddrs
        companyDetails.isInternational = pmCompanyConfig.isInternational
        companyDetails.pmCompanyConfig = pmCompanyConfig
        const validation_res = await validateInputs(companyDetailSchema, companyDetails, pmCompanyConfig)

        if(!companyDetails.partialOnboarding && [2, 3].includes(companyDetails.buyerSeller) && !companyDetails.gstCert && companyDetails.gstinCode){
            return dispatch(raiseToast({ severity: 'warn', detail: `Upload ${pmCompanyConfig.GSTINLabel} certificate` }))
        }

        if (validation_res) {
            if (validation_res.error) {
                setFormErrors(validation_res.error)
                Object.keys(validation_res.error).map(eachError => {
                    dispatch(raiseToast({ severity: 'warn', detail: validation_res.error[eachError], life: 3000 }))
                })
            }
            else {

                let updated_company_details = { ...companyDetails, ...validation_res.result }
                setCompanyDetails({ ...companyDetails, ...validation_res.result })
                setFormErrors({})

                if (is_buyer) {
                    delete updated_company_details.ownershipTypeId
                    delete updated_company_details.sizeId
                    delete updated_company_details.businessTypeId
                    delete updated_company_details.turnoverCategoryId
                    delete updated_company_details.isMSMEDRegd
                    delete updated_company_details.tdsSection194q
                    delete updated_company_details.gstCert
                    delete updated_company_details.aadharCert
                    delete updated_company_details.panCert
                    delete updated_company_details.msmedCert
                    delete updated_company_details.incorporationCert
                    updated_company_details.isBuyer = true

                }else{

                    if(updated_company_details.buyerSeller !== 1 && !updated_company_details?.partialOnboarding){
                        if(updated_company_details.isMSMEDRegd != ""){
                            if (updated_company_details.isMSMEDRegd === "Registered") {
                                updated_company_details.isMSMEDRegd = true
                            }
                            else {
                                updated_company_details.isMSMEDRegd = false
                            }
                            
                            if (!pmCompanyConfig.isInternational){
                                if(updated_company_details.isMSMEDRegd && !updated_company_details.msmedCert){
                                    return dispatch(raiseToast({ severity: 'warn', detail: "Please upload msmed certificate", life: 3000 }))
                                }else{
                                    if(!updated_company_details.isMSMEDRegd && !updated_company_details.msmedCert){
                                        return dispatch(raiseToast({ severity: 'warn', detail: "Please upload pdf or screenshot of the email confirmation from the vendor about MSMED act registration status", life: 3000 }))
                                    }
                                }
                            }
                        }
                        else{
                            delete updated_company_details.isMSMEDRegd
                        }

                        if(!updated_company_details.gstCert && updated_company_details.gstinCode){
                        }
                    }
                }

                if (pmCompanyConfig.isInternational){
                    if (!updated_company_details.companyBillAddrs?.length){
                        return dispatch(raiseToast({severity:'warn', detail: "Please Add billing address", life: 3000}))
                    }
                }

                let notValidGSTINs = []
                if (!pmCompanyConfig.isInternational){
                    if (updated_company_details.companyGSTINs.length > 0) {
                        updated_company_details.companyGSTINs = updated_company_details.companyGSTINs?.map(eachVerifiedGSTIN => {
                            const relatedState = statesDetails?.find(eachState => eachState?.stateId === parseInt(eachVerifiedGSTIN?.gstin?.slice(0, 2)))

                            let tradeName = ''
                            if (eachVerifiedGSTIN?.tradeNam) {
                                tradeName = eachVerifiedGSTIN?.tradeNam
                            } else {
                                tradeName = companyDetails.companyName
                            }

                            let ledgerName = ''
                            let stateCode = relatedState?.stateCode || ''
                            let pan = companyDetails.panCode

                            if(!eachVerifiedGSTIN?.gstin){
                                notValidGSTINs.push(eachVerifiedGSTIN)
                            }else{
                                ledgerName = `${tradeName}_${stateCode}_${pan.slice(-4)}_${eachVerifiedGSTIN.gstin.slice(-4)}`
                            }

                            return { ...eachVerifiedGSTIN, gstinCode: eachVerifiedGSTIN?.gstin, ledgerName: ledgerName, stateId: relatedState?.stateId }
                        })
                        if(notValidGSTINs.length > 0){
                            return dispatch(raiseToast({severity:'warn', detail: "GSTINs verification was failed, Please check the GSTINs with pan has same entity. If not found contact tech support.", life: 3000}))
                        }
                    }
                }else{
                    if (updated_company_details.companyBillAddrs.length > 0) {
                        updated_company_details.companyBillAddrs = updated_company_details.companyBillAddrs?.map(eachBillAddr => {
                            const relatedState = statesDetails?.find(eachState => eachState.stateId === eachBillAddr.stateId)

                            let ledgerName = ''
                            if (eachBillAddr?.tradeNam) {
                                ledgerName = eachBillAddr?.tradeNam + "_" + relatedState?.stateCode
                            } else {
                                if (relatedState?.stateCode){
                                    ledgerName = companyDetails.companyName + "_" + relatedState?.stateCode
                                }else{
                                    ledgerName = companyDetails.companyName
                                }
                            }

                            return { ...eachBillAddr, gstinCode: companyDetails?.gstinCode, ledgerName: ledgerName }
                        })
                    }
                }
                
                if(GSTINs.length > 0 && !updated_company_details.gstinCode){

                }else{
                    if(updated_company_details.gstinCode){
                        const relatedCompanyPrimaryGSTIN = companyGSTINs?.find(eachGSTIN => eachGSTIN?.gstinCode === companyDetails?.gstinCode)

                        if(relatedCompanyPrimaryGSTIN){
                            const relatedState = statesDetails?.find(eachState => eachState?.stateId === parseInt(relatedCompanyPrimaryGSTIN?.gstin?.slice(0, 2)))

                            let ledgerName = ''
                            let tradeName = ''
                            if (relatedCompanyPrimaryGSTIN?.tradeNam) {
                                tradeName = relatedCompanyPrimaryGSTIN.tradeNam
                            } else {
                                tradeName = companyDetails.companyName
                            }

                            let stateCode = relatedState?.stateCode || ''
                            let pan = companyDetails.panCode

                            ledgerName = `${tradeName}_${stateCode}_${pan.slice(-4)}_${relatedCompanyPrimaryGSTIN.gstin.slice(-4)}`

                            relatedCompanyPrimaryGSTIN.ledgerName = ledgerName
                            relatedCompanyPrimaryGSTIN.stateId = relatedState?.stateId
                        }

                        updated_company_details.gstinVerifiedObj = relatedCompanyPrimaryGSTIN
                    }
                }

                if (updated_company_details.paymentTerms) {
                    let total_payment_percentage = 0
                    if (updated_company_details.paymentTerms?.payAdvPO || updated_company_details.paymentTerms?.payAdvDelivery || updated_company_details.paymentTerms?.payPDCDelivery || updated_company_details.paymentTerms?.payOnDelivery || updated_company_details.paymentTerms?.payCredit) {
                        if (updated_company_details.paymentTerms?.payAdvPO) {
                            updated_company_details.paymentTerms.payAdvPO = parseFloat(updated_company_details.paymentTerms.payAdvPO)
                            total_payment_percentage += updated_company_details.paymentTerms.payAdvPO
                        }
                        if (updated_company_details.paymentTerms?.payAdvDelivery) {
                            updated_company_details.paymentTerms.payAdvDelivery = parseFloat(updated_company_details.paymentTerms.payAdvDelivery)
                            total_payment_percentage += updated_company_details.paymentTerms.payAdvDelivery
                        }
                        if (updated_company_details.paymentTerms?.payOnDelivery) {
                            updated_company_details.paymentTerms.payOnDelivery = parseFloat(updated_company_details.paymentTerms.payOnDelivery)
                            total_payment_percentage += updated_company_details.paymentTerms.payOnDelivery
                        }

                        if ((updated_company_details.paymentTerms?.payCredit && updated_company_details.paymentTerms?.payCredit != 0) || (updated_company_details.paymentTerms?.payPDCDelivery && updated_company_details.paymentTerms?.payPDCDelivery != 0)) {
                            if (updated_company_details.paymentTerms?.payCredit && updated_company_details.paymentTerms?.payCredit != 0) {
                                updated_company_details.paymentTerms.payCredit = parseFloat(updated_company_details.paymentTerms.payCredit)
                                total_payment_percentage += updated_company_details.paymentTerms.payCredit
                            }
                            if (updated_company_details.paymentTerms?.payPDCDelivery && updated_company_details.paymentTerms?.payPDCDelivery != 0) {
                                updated_company_details.paymentTerms.payPDCDelivery = parseFloat(updated_company_details.paymentTerms.payPDCDelivery)
                                total_payment_percentage += updated_company_details.paymentTerms.payPDCDelivery
                            }
                            if (!updated_company_details.paymentTerms?.creditPeriodId) {
                                return dispatch(raiseToast({ severity: 'warn', detail: "Please select credit period", life: 3000, }))
                            }
                        } else {
                            delete updated_company_details.paymentTerms.creditPeriodId
                        }
                    }else{
                        if(!updated_company_details.partialOnboarding){
                            return dispatch(raiseToast({ severity: 'warn', detail: "Please enter payment terms", life: 3000 }))
                        }
                    }
                    
                    if (updated_company_details.paymentTerms?.payAdvPO || updated_company_details.paymentTerms?.payAdvDelivery || updated_company_details.paymentTerms?.payPDCDelivery || updated_company_details.paymentTerms?.payOnDelivery || updated_company_details.paymentTerms?.payCredit) {
                        if (total_payment_percentage !== 100 && total_payment_percentage != 0) {
                            return dispatch(raiseToast({ severity: 'warn', detail: "Total percentage of payment terms should be 100", life: 3000 }))
                        }
                    }
                }
                else {
                    if(!updated_company_details.partialOnboarding){
                        return dispatch(raiseToast({ severity: 'warn', detail: "Please enter payment terms", life: 3000 }))
                    }
                }

                if (!updated_company_details?.panCode){
                    updated_company_details.companyShortName = updated_company_details?.companyName
                    updated_company_details.panCode = null
                    if (!pmCompanyConfig.isInternational){
                        updated_company_details.gstinCode = null
                    }
                }else {
                    if (!pmCompanyConfig.isInternational){
                        if(!isPANVerified){
                            return dispatch(raiseToast({severity:'warn', detail: "Please verify pan code", life: 3000}))
                        }
                    }
                    
                    const relatedCompanyGSTIN = companyGSTINs?.find(eachGSTIN => eachGSTIN?.gstinCode === updated_company_details?.gstinCode)
                    if(relatedCompanyGSTIN && relatedCompanyGSTIN.tradeNam){
                        updated_company_details.companyShortName = relatedCompanyGSTIN.tradeNam
                    }else{
                        updated_company_details.companyShortName = updated_company_details.companyName
                    }
                }

                if(updated_company_details.partialOnboarding){
                    updated_company_details.statusId = 5
                }

                updated_company_details.createdBy = userId
                if(updated_company_details.groupId){
                    updated_company_details.groupId = updated_company_details?.groupId?.groupId
                }

                if (updated_company_details.clientSuccessManagerId) {
                    updated_company_details.clientSuccessManagerId = updated_company_details?.clientSuccessManagerId?.userId
                }

                let companyHODUsers = []
                if(updated_company_details.companyUsers && updated_company_details.companyUsers?.length > 0){
                    let relatedHODRole = INITIAL_COMPANY_ROLE.map(eachRole => eachRole.roleName === "HOD")
                    updated_company_details.companyUsers?.map(eachUser => {
                        if(eachUser.companyRoleId === relatedHODRole?.roleId){
                            companyHODUsers.push(eachUser)
                        }
                    })
                }

                if(companyHODUsers.length > 1){
                    return dispatch(raiseToast({ severity: 'warn', detail: "Company has only 1 HOD", life: 3000 }))
                }

                let confirmMessage = "Do you want to save the company..?"
                if(!updated_company_details.gstinCode || updated_company_details?.gstinCode?.trim() === ''){
                    updated_company_details.gstinCode = null
                    confirmMessage = `Company will get added as ${updated_company_details.isBuyer ? "URP" : "URD"}. Do you want to save the company..?`
                }else{
                    if(updated_company_details?.gstinCode?.trim()){
                        updated_company_details.gstinCode = updated_company_details?.gstinCode?.trim()

                        if (!pmCompanyConfig.isInternational){
                            if(updated_company_details.gstinCode !== "URD" && updated_company_details.gstinCode !== "URP"){
                                if (updated_company_details.gstinCode?.length !== 15) {
                                    return dispatch(raiseToast({ severity: 'warn', detail: "GSTIN must be exactly 15 characters only", life: 3000 }))
                                }
                                if (!GSTIN_REGEX_FORMAT.test(updated_company_details.gstinCode)) {
                                    return dispatch(raiseToast({ severity: 'warn', detail: "Please enter valid GSTIN", life: 3000 }))
                                }
                                let panAndGstinMatch = panAndGstinMatchValidation(updated_company_details.panCode, updated_company_details.gstinCode)
                                if (!panAndGstinMatch) {
                                    return dispatch(raiseToast({ severity: 'warn', detail: "GSTIN and PAN entered are not for the same entity.", life: 3000 }))
                                }
                            }
                        }
                    }
                }

                let approvalConfirmMessage = ""

                if([2, 3].includes(updated_company_details.buyerSeller)){
                    if(updated_company_details.enableServicePurchase && updated_company_details.tdsSectionId !== 1){
                        updated_company_details.isTDSApproval = true
                        approvalConfirmMessage = "Company TDS type is Services. \n" 
                    }

                    let relatedCompanyBranchesPaymentTermsApproval = null
                    if (approvals.length){
                        relatedCompanyBranchesPaymentTermsApproval = approvals.find(eachApproval => eachApproval.approvalTypeId === 19 && eachApproval.statusId === 1) // APPROVAL_CHANGE find by typeId
                    }
                    if(relatedCompanyBranchesPaymentTermsApproval){
                        if(updated_company_details.paymentTerms?.payAdvPO > 0 
                            || updated_company_details.paymentTerms?.payAdvDelivery > 0 
                            || updated_company_details.paymentTerms?.payOnDelivery > 0 
                            || updated_company_details.paymentTerms?.payPDCDelivery > 0
                            || (updated_company_details.paymentTerms?.payCredit === 100 && updated_company_details.paymentTerms?.creditPeriodId < 8)
                        ){
                            updated_company_details.isPaymentTermsApproval = true
                        }

                        if(updated_company_details.isPaymentTermsApproval){
                            //approvalConfirmMessage += "Payment terms are not favorable \n" 
                        }
                    }

                    if(!updated_company_details.partialOnboarding){
                        updated_company_details.isCompanyOnboardingApproval = true
                    }
                }

                if (updated_company_details && !updated_company_details.isPaymentTermsApproval) {
                    updated_company_details.isPaymentTermsChanged = true
                    updated_company_details.previousPaymentTerms = null
                }

                updated_company_details.hodPhoneNo = combineISDCodeWithPhoneNumber(updated_company_details.hodISDCode, updated_company_details.hodPhoneNo)
                
                if(updated_company_details?.companyUsers?.length > 0){
                    updated_company_details.companyUsers.map(eachUser => {
                        eachUser.phoneNumber = combineISDCodeWithPhoneNumber(eachUser.ISDCode, eachUser.phoneNumber)
                        return eachUser
                    })
                }

                if(brandCertificates.length){
                    updated_company_details.brandCertificates = brandCertificates
                }

                // if (tagOptions.length) {
                //     let tagsObj = {}
                //     let missingTags = []
                    
                //     tagOptions.forEach(eachTag => {
                //         if (eachTag.tagName) {
                //             let value
                //             if(['integer', 'string', 'select'].includes(eachTag.tagType.toLowerCase())){
                //                 value = eachTag.tagValue?.trim()
                //                 if (!value) {
                //                     missingTags.push(eachTag.tagLabel || eachTag.tagName)
                //                 }
                //             }else if(['boolean'].includes(eachTag.tagType.toLowerCase())){
                //                 value = eachTag.tagValue
                //             } else if(['multiselect'].includes(eachTag.tagType.toLowerCase())){
                //                 value = eachTag.tagValue
                //                 if (!value || (value && value.length === 0)) {
                //                     missingTags.push(eachTag.tagLabel || eachTag.tagName)
                //                 }
                //             }

                //             tagsObj[eachTag.tagName] = value
                //         }
                //     })
                    
                //     if (missingTags.length) {
                //         return dispatch(raiseToast({ severity: 'warn', detail: `Please enter value for ${missingTags.join(", ")} tags`, life: 3000 }))
                //     }

                //     updated_company_details.tags = Object.keys(tagsObj).length > 0 ? tagsObj : null
                // } else {
                //     updated_company_details.tags = null
                // }
                
                if (updated_company_details.isTDSApproval || updated_company_details.isPaymentTermsApproval || updated_company_details.isCompanyOnboardingApproval) {
                    if(updated_company_details.isTDSApproval || updated_company_details.isPaymentTermsApproval){
                        approvalConfirmMessage +=  "This needs approval before seller PO created."
                    }

                    if(updated_company_details.isCompanyOnboardingApproval){
                        approvalConfirmMessage += "\nCompany is fully onboarding, this needs approval from Data Ops team"
                    }

                    if(window.confirm(approvalConfirmMessage)){
                        setAddCompanyDetails({ ...updated_company_details, confirmMessage })
                        setVisibleApprovalRemarks(true)
                    }
                } else {
                    if (window.confirm(confirmMessage)) {
                        setIsLoaderVisible(true)
                        const addCompanyDataResponse = await insertCompany(updated_company_details)
                        console.log("addCompanyData - response", addCompanyDataResponse)
                        if (addCompanyDataResponse?.failure) {
                            setIsLoaderVisible(false)
                            return dispatch(raiseToast({ severity: 'error', detail: addCompanyDataResponse?.data?.error, life: 3000 }))
                        } else {
                            setIsLoaderVisible(false)
                            const data = addCompanyDataResponse.data
                            const message = data?.message
                            if (data?.success) {
                                dispatch(raiseToast({ severity: 'success', detail: data.message, life: 3000 }))
                                navigate(`/company/users/${data.data}`);
                            }
                            else {
                                dispatch(raiseToast({ severity: 'error', detail: message, life: 3000 }))
                            }
                        }
                    }
                }
            }
        }
    }

    const addCompany = async() => {
        if(addCompanyDetails.isTDSApproval){
            if (!tdsApprovalRemarks || (tdsApprovalRemarks && tdsApprovalRemarks?.trim() === '')){
                return dispatch(raiseToast({ severity: 'warn', detail: "Enter services type details that will be procure from this vendor", life: 3000 }))
            }else{
                if(tdsApprovalRemarks.trim().length <= 20){
                    return dispatch(raiseToast({ severity: 'warn', detail: "TDS service remarks should be atleast 20 characters", life: 3000 }))
                }
            }
        }

        if (addCompanyDetails.isPaymentTermsApproval && (!paymentTermsApprovalRemarks || (paymentTermsApprovalRemarks && paymentTermsApprovalRemarks?.trim() === ''))){
            return dispatch(raiseToast({ severity: 'warn', detail: "Enter payment terms approval remarks", life: 3000 }))
        }

        if (addCompanyDetails.isCompanyOnboardingApproval && (!companyOnboardingApprovalRemarks || (companyOnboardingApprovalRemarks && companyOnboardingApprovalRemarks?.trim() === ''))){
            return dispatch(raiseToast({ severity: 'warn', detail: "Enter company onboarding approval remarks", life: 3000 }))
        }

        if(!addCompanyDetails.partialOnboarding && [2, 3].includes(addCompanyDetails.buyerSeller) && !addCompanyDetails.gstCert && addCompanyDetails.gstinCode){
            return dispatch(raiseToast({ severity: 'warn', detail: `Upload ${pmCompanyConfig.GSTINLabel} certificate` }))
        }

        if(addCompanyDetails.gstinCode){
            const relatedCompanyGSTIN = GSTINs.find(eachCompanyGSTIN => eachCompanyGSTIN.gstinCode === addCompanyDetails.gstinCode)
            if(relatedCompanyGSTIN && [2, 20].includes(relatedCompanyGSTIN.statusId)){
                return dispatch(raiseToast({ severity: 'error', detail: "Primary GSTIN cannot be INACTIVE/BLACKLISTED"}))
            }   
        }

        addCompanyDetails.tdsApprovalRemarks = tdsApprovalRemarks.trim()
        if(selectedSACCode){
            addCompanyDetails.tdsApprovalRemarks = `SACCode: ${selectedSACCode.HSNCode}-${selectedSACCode.HSNTitle}. \n ` + tdsApprovalRemarks.trim()
        }
        addCompanyDetails.paymentTermsApprovalRemarks = paymentTermsApprovalRemarks.trim()
        addCompanyDetails.pmCompanyId = activeUserRole.companyId
        addCompanyDetails.companyOnboardingRemarks = companyOnboardingApprovalRemarks.trim()
        
        if (window.confirm(addCompanyDetails?.confirmMessage)) {
            setIsLoaderVisible(true)
            const addCompanyDataResponse = await insertCompany(addCompanyDetails)
            console.log("addCompanyData - response", addCompanyDataResponse)
            if (addCompanyDataResponse?.failure){
                setIsLoaderVisible(false)
                return dispatch(raiseToast({ severity: 'error', detail: addCompanyDataResponse?.data?.error, life: 3000 }))
            }else{
                setIsLoaderVisible(false)
                const data = addCompanyDataResponse.data
                const message = data?.message
                if (data?.success) {
                    dispatch(raiseToast({ severity: 'success', detail: data.message }))
                    navigate(`/company/users/${data.data}`);
                }
                else {
                    setAddCompanyDetails({})
                    dispatch(raiseToast({severity: 'error', detail: message, life: 3000 }))
                }
            }
        }
    }

    const panAndGstinMatchValidation = (panCode, gstin) => {
        if(panCode && gstin){
            if(gstin.slice(2,12) !== panCode){
                return false
            }
            return true
        }
    }

    const addCompanyRole = () => {
        const newCompanyRoleObj = {
            roleId: uuidv4(),
            roleName: ''
        }
        setCompanyRoles([...companyRoles, newCompanyRoleObj])
    }

    const deleteCompanyRole = (selectedCompanyRoleId) => {
        const relatedCompanyUser = companyUsers.find(user => user.companyRoleId === selectedCompanyRoleId)
        if(relatedCompanyUser){
            return dispatch(raiseToast({severity:'warn', detail: "User active with this role, Can't delete this company role.", life: 3000}))
        }
        const relatedCompanyRoles = companyRoles.filter(role => role.roleId !== selectedCompanyRoleId)
        setCompanyRoles(role => ([...relatedCompanyRoles]))
    }

    const addCompanyUser = () => {
        const newCompanyUserobj = {
            userId: uuidv4(),
            firstName: '',
            lastName: '',
            ISDCode: '',
            phoneNumber: '',
            emailId: '',
            companyRoleId: null,
        }
        setcompanyUsers([...companyUsers, newCompanyUserobj])
    }

    const deleteCompanyUser = (companyUserId) => {
        const relatedCompanyUsers = companyUsers.filter(user => user.userId != companyUserId)
        setcompanyUsers([...relatedCompanyUsers])
    }

    const handleTextInputChange = (event) => {
        if (event.target.name) {
            if (event.target.name === "prefPMBranchId" && event.target.value === 0 && !prefPMBranchPermissionDetails.isPermitted) {
                return
            }
            
            companyDetails[event.target.name] = event.target.value

            if (event.target.name === "buyerSeller") {
                if([2, 3].includes(event.target.value)  && !companyDetails.enableServicePurchase){
                    companyDetails["tdsSectionId"] = 1
                    if (event.target.value === 2 && pmCompanyConfig.isInternational){
                        companyDetails["supplyTypeId"] = null
                    }
                }else{
                    companyDetails["tdsSectionId"] = null
                }

                if([1, 3].includes(event.target.value) && pmCompanyConfig.isInternational){
                    companyDetails["supplyTypeId"] = 1
                }

                if(pmCompanyDetails.companyBankAccounts.length === 1){
                    companyDetails.prefPMBankId = pmCompanyDetails.companyBankAccounts[0].bankAccId
                }

                if(pmCompanyDetails.companyBranches.length === 1){
                    companyDetails.prefPMBranchId = pmCompanyDetails.companyBranches[0].branchId
                }

                if([2, 3].includes(event.target.value)){
                    if(relatedCompanyOwnershipTypes && relatedCompanyOwnershipTypes.length === 1){
                        companyDetails.ownershipTypeId = relatedCompanyOwnershipTypes[0].ownershipTypeId
                    }
                    if(initialData.companyBusinessTypesData.length === 1){
                        companyDetails.businessTypeId = initialData.companyBusinessTypesData[0].businessTypeId
                    }
                    if(initialData.companySizeCategoriesData.length === 1){
                        companyDetails.sizeId = initialData.companySizeCategoriesData[0].sizeCategoryId
                    }
                    if(initialData.companyTurnoverCategoriesData.length === 1){
                        companyDetails.turnoverCategoryId = initialData.companyTurnoverCategoriesData[0].turnoverCategoryId
                    }
                    if (materialCategories.length === 1) {
                        if (!companyDetails.indicativeIndustryList) {
                            companyDetails.indicativeIndustryList = []
                        }
                        if(companyDetails.indicativeIndustryList.length === 0){
                            companyDetails.indicativeIndustryList.push(materialCategories[0].categoryId)
                        }
                    }
                }
                else{
                    companyDetails.ownershipTypeId = null
                    companyDetails.businessTypeId = null
                    companyDetails.sizeId = null
                    companyDetails.turnoverCategoryId = null
                    companyDetails.indicativeIndustryList = []
                }

                if([1, 3].includes(event.target.value)){
                    if(initialData.companySupplyTypesData.length === 1){
                        companyDetails.supplyTypeId = initialData.companySupplyTypesData[0].supplyTypeId
                    }
                    if(clientSuccessManagers && clientSuccessManagers.length === 1){
                        companyDetails.clientSuccessManagerId = clientSuccessManagers[0]
                    }
                }
                else{
                    companyDetails.supplyTypeId = null
                    companyDetails.clientSuccessManagerId = null
                }
            }

            if (event.target.name === "gstinCode") {
                if (event.target.value?.trim()?.length !== 15) {
                }
                else{
                    const relatedCompanyLegalName = companyGSTINs?.find(eachGSTIN => eachGSTIN?.gstinCode === event.target.value)
                    companyDetails.companyShortName = relatedCompanyLegalName?.tradeNam
                }

                if (pmCompanyConfig.isInternational){
                    let newCompanyGSTIN = {
                        gstinCode: event.target.value,
                        createdBy: userDetails.userId,
                        updatedBy: userDetails.userId,
                        tradeNam: companyDetails.companyName
                    }

                    setCompanyGSTINs([newCompanyGSTIN])
                }
            }

            if(event.target.name === "pinCode" && (event.target.value).length === pmCompanyConfig.pinCodeLength ){
                const relatedPinCode = pinCodesData?.find(eachPincode => {
                    if(eachPincode.pinCode === parseInt(event.target.value)){
                        return eachPincode
                    }
                })

                if((relatedPinCode && relatedPinCode?.stateId) || (pmCompanyConfig.isInternational)){
                    if (!pmCompanyConfig.isInternational){
                        const relatedState = statesDetails?.find(eachState => {
                            if(eachState.stateId === relatedPinCode.stateId){
                                companyDetails["stateId"] = eachState?.stateId
                                return eachState
                            }
                        })
                
                        initialData?.countryData?.find(eachCountry => {
                            if(eachCountry.countryId === relatedState.countryId){
                                companyDetails["countryId"] = eachCountry.countryId
                            }
                        })
                    } else{
                        companyDetails["stateId"] = pmCompanyConfig.defaultStateId
                        companyDetails["countryId"] = pmCompanyConfig.defaultCountryId
                    }
                }
                else{
                    if (!pmCompanyConfig.isInternational){
                        return dispatch(raiseToast({severity:'warn', detail: "Please enter valid pincode", life: 3000}))
                    }
                }
            }else{
                if(event.target.name === "pinCode"){
                    companyDetails["stateId"] = null
                    companyDetails["countryId"] = null
                }
            }

            if(event.target.name === "panCode"){
                if(event?.target?.value[3] === "P"){
                    companyDetails["ownershipTypeId"] = 1
                }else{
                    companyDetails["ownershipTypeId"] = null
                }

                if(companyGSTINs.length>0 || GSTINs.length>0){
                    setCompanyGSTINs([])
                    setGSTINs([])
                }

                if(companyDetails.gstinCode){
                    companyDetails['gstinCode'] = ''
                }

                if(isPANVerified){
                    setIsPANVerified(null)
                }
            }

            if(event.target.name === "tdsSectionId"){
                setVisibleSACCode(true)
            }

            if (event.target.name === "prefPMBranchId" && event.target.value === 0 && !prefPMBranchPermissionDetails.isPermitted) {
                return
            }
            
            setCompanyDetails({ ...companyDetails })
        }
    }

    const handleIndustryListOptionDisabled = (category) => {
        return category.optionDisabled
    }

    const handlePaymentTermsChange = (event) => {
        if (event.target.name) {
            const payment_details = companyDetails.paymentTerms ? companyDetails.paymentTerms : {}
            if (event.target.name === "creditPeriodId"){
                let isPermitted = false 
                let relatedCreditPeriod = seller_credit_period_terms?.find(eachCreditPeriodTerm => eachCreditPeriodTerm?.creditPeriodId === event.target.value)
                if (relatedCreditPeriod?.creditPeriod < 30){
                    const permissionDetails = checkPermissions({...userDetails, permissions: [134]})  //made true temporarily beacuse this check is not needed as approval is created
                    isPermitted = permissionDetails.isPermitted
                    if (isPermitted){
                        payment_details[event.target.name] = event.target.value
                        companyDetails.paymentTerms = payment_details
                        setCompanyDetails(details => ({ ...companyDetails }))
                    }else{
                        dispatch(raiseToast({ severity: 'warn', detail: `Credit Period Should not be less than 30 days`, life: 3000 }));
                    }
                }else{
                    payment_details[event.target.name] = event.target.value
                    companyDetails.paymentTerms = payment_details
                    setCompanyDetails(details => ({ ...companyDetails }))
                }
            }else{
                payment_details[event.target.name] = event.target.value
                companyDetails.paymentTerms = payment_details
                setCompanyDetails(details => ({ ...companyDetails }))
            }
        }
    }

    const handleToggleSwitchButtonChange = (event) => {
        if (event.target.name) {
            companyDetails[event.target.name] = event.target.value
            setCompanyDetails({ ...companyDetails })
            if (event.target.name == "tdsSection194q") {
                setTdsSection194q(event.value)
            }
            else if (event.target.name == "partialOnboarding") {
                setpartialOnboarding(event.value)
            }
            else if (event.target.name == 'enableServicePurchase'){
                companyDetails["enableServicePurchase"] = event.value
                if(event.value){
                    companyDetails["tdsSectionId"] = null
                }else{
                    companyDetails["tdsSectionId"] = 1
                }
                setCompanyDetails({...companyDetails})
            }
        }
    }

    const handleMSMEDChange = (event) => {
        companyDetails['isMSMEDRegd'] = event.value

        if(companyDetails.paymentTerms.creditPeriodId){
            let relatedCreditPeriod = initialData.companyCreditPeriodsData.find(obj => obj.creditPeriod >= 45 && obj.creditPeriodId === companyDetails.paymentTerms.creditPeriodId)
            if(relatedCreditPeriod){
                delete companyDetails.paymentTerms.creditPeriodId
            }
        }

        if(event.value !== "Registered"){
            companyDetails.companyMSMEDTypeId = null
        }

        setCompanyDetails({ ...companyDetails })
    }

    const handleCompanyRoleChange = (event, companyRoleId) => {
        companyRoles.map((role) => {
            if (role.roleId == companyRoleId) {
                role.roleName = event.target.value
            }
        })
        setCompanyRoles([...companyRoles])
    }

    const handleCompanyRoleInputBlur = (event, companyRoleId) => {
        let relatedCompanyRole = companyRoles.find(role => role.roleId === companyRoleId);

        if (relatedCompanyRole) {
            const inputRoleName = event.target.value?.trim().toLowerCase();

            const isRoleNameExists = companyRoles.some(role => role.roleId !== companyRoleId && role.roleName.toLowerCase() === inputRoleName);

            if (isRoleNameExists) {
                relatedCompanyRole.roleName = '';
                dispatch(raiseToast({ severity: 'warn', detail: 'Company role already exists', life: 3000 }));
            } else {
                relatedCompanyRole.roleName = inputRoleName.toUpperCase();
            }
        }
    
        setCompanyRoles([...companyRoles])
    }

    const handleCompanyUsersChange = (event, companyUserId) => {
        companyUsers.map((user) => {
            if (user.userId == companyUserId) {
                user[event.target.name] = event.target.value
            }
        })
        setcompanyUsers([...companyUsers])
    }

    const handleSubmitBllAddr = async (billAddrObj) => {
        setCompanyBillAddrs(prevState => ([...prevState, billAddrObj]))
        setVisibleAddNewBillingAddr(false)
    }
    
    const fileUploadHandler = async ({ files, options }, doc_name) => {
        const { fileArr, error, errorMsg } = await getUploadedFileObj({ files, options, documentName: doc_name })
        if (error) {
            return dispatch(raiseToast({ severity: 'error', detail: errorMsg, life: 3000 }))
        }
        const fileObj = fileArr[0]

        uploadCompanyRelatedCertificates(doc_name, fileObj.name, fileObj.dataURI , fileObj.inputName)
    }

    const uploadCompanyRelatedCertificates = async (doc_name, file_name, data_uri, input_name) => {
        let data = {
            doc_name,
            file_name,
            data_uri,
            objectURL: data_uri
        }
        setIsLoaderVisible(true)
        let response = await uploadFile(data)
        
        setIsLoaderVisible(false)
        if (response) {
            companyDetails[input_name] = response.data
            setCompanyDetails({ ...companyDetails })
        }
    }

    const removeCompanyRelatedCertificates = (certificateName) => {
        delete companyDetails[certificateName]
        setCompanyDetails({ ...companyDetails })
    }

    const searchClientSuccessManagers = (event) => {
        const relatedClientSuccessManagers = clientSuccessManagers.filter(eachUser => eachUser.fullName.toLowerCase().includes(event.query.trim().toLowerCase()))
        setSearchedClientSuccessManagers([...relatedClientSuccessManagers])
    }

    const handlePreferredPaymentModeChange = (event) => {
        const updatedCompanyDetails = { ...companyDetails, preferredPaymentMode: event.value }

        setCompanyDetails({ ...updatedCompanyDetails })
    }


    let is_buyer = false
    let is_seller = false
    let is_buyer_seller = false
    const buyer_seller = initialData?.companyTypesData?.find(obj => obj.companyTypeId == companyDetails.buyerSeller)
    
    if (buyer_seller) {
        if (buyer_seller.companyType == "Buyer") {
            is_buyer = true
        }
        else if (buyer_seller.companyType == "Seller") {
            is_seller = true
        }
        else if (buyer_seller.companyType == "Both") {
            is_buyer_seller = true
        }
    }

    const user_role_list = []
    companyRoles.map(role => {
        if (role.roleName) {
            user_role_list.push(role.roleName)
        }
    })
    
    let user_roles_without_hod = user_role_list.filter(role => role !== companyDetails.hodRole && role != "BRANCH HEAD")
    
    let seller_credit_period_terms = initialData.companyCreditPeriodsData
    if (pmCompanyConfig.isMSMEDApplicable && (companyDetails.isMSMEDRegd == "Registered" || companyDetails.isMSMEDRegd == "Not Registered")) {
        seller_credit_period_terms = seller_credit_period_terms.filter(obj => obj.creditPeriod <= 45)
    } else {
        seller_credit_period_terms = initialData.companyCreditPeriodsData
    }


    let total_payment = 0
    let payment_terms = {...companyDetails.paymentTerms}
    delete payment_terms.creditPeriodId
    const payment_values = Object.values(payment_terms)
    payment_values.map((value) => {
        if(value){
            total_payment += parseFloat(value)
        }
    })

    const handleVerifyClick = async () => {
        if(!companyDetails.companyName || companyDetails.companyName?.trim() === ''){
            return dispatch(raiseToast({ severity: 'warn', detail: "Please enter company name", life: 3000 }))
        }

        setIsLoaderVisible(true)
        setIsGSTINDataLoading(true)
        const response = await verifyGSTINsByPanNumber(companyDetails?.panCode)
        
        setIsLoaderVisible(false)
        if (response?.failure){
            setGSTINs([])
            setCompanyGSTINs([])
            setIsGSTINDataLoading(false)
            setIsPANVerified(true)
            return dispatch(raiseToast({ severity: 'error', detail: "No GSTINs found for this PAN - Please enter GSTIN manually", life: 3000 }))
        }else{
            let sortedGSTINs = sortArrayOfObjectsInAlphabeticalOrder(response?.data?.GSTINs, "gstIN")

            sortedGSTINs = sortedGSTINs.filter(eachGSTINObj => eachGSTINObj.status === "Active")
            
            let companyGSTINsWithTradeName = sortedGSTINs.map(eachGSTIN => {
                // let relatedState = statesDetails?.find(eachState => eachState?.stateId === parseInt(eachGSTIN?.gstIN?.slice(0, 2)))
                let eachVerifiedGSTIN = response?.data?.verification?.find(eachVerifiedGSTIN => eachGSTIN.gstIN === eachVerifiedGSTIN.gstin)
                let tradeName = ""
                if (eachVerifiedGSTIN?.tradeNam) {
                    tradeName = eachVerifiedGSTIN?.tradeNam //+ "_" + relatedState?.stateCode
                }
                // else {
                //     tradeName = companyDetails?.companyName?.trim() + "_" + relatedState?.stateCode
                // }
                return { ...eachGSTIN, tradeName }
            })

            //setGSTINs(sortedGSTINs)
            setGSTINs(companyGSTINsWithTradeName)

            let sortedGSTINsVerification = sortArrayOfObjectsInAlphabeticalOrder(response?.data?.verification, "gstin")
            let updatedGSTINs = sortedGSTINsVerification?.map(eachVerifiedGSTIN => {
                return { ...eachVerifiedGSTIN, gstinCode: eachVerifiedGSTIN?.gstin }
            })

            if(sortedGSTINs.length > 0){
                dispatch(raiseToast({ severity: 'success', detail: "GSTINs found - Please select from dropdown", life: 3000 }))
            }
            else{
                dispatch(raiseToast({ severity: 'warn', detail: "GSTINs not found - You can enter manually", life: 3000 }))
            }

            setCompanyGSTINs(updatedGSTINs)
            setIsGSTINDataLoading(false)
            setIsPANVerified(true)
        }
    }

    const searchCompanyGroupTypes = (event) => {
        const relatedCompanygroups = initialData?.companyGroupsData.filter(group => group.groupName.toLowerCase().startsWith(event.query.trim().toLowerCase()))
        if(relatedCompanygroups.length > 0){
            return setRealtedCompanyGroupTypes(relatedCompanygroups);
        }
        setRealtedCompanyGroupTypes(["this is empty"])
    }

    const companyGSTINOptionTemplate = (option) => {
        let lineItemColor = ``
        if ([2, 20].includes(option.statusId)) {
            lineItemColor = `#F1592A`
        }
        else if ([21, 22].includes(option.statusId)) {
            lineItemColor = `#cfbf32`
        }
        else {
            lineItemColor = `#13A89D`
        }

        let labelText = ``
        if(option.tradeName){
            labelText = `${option.gstIN}${option.statusId === 20 ? ' ᵇˡᵃᶜᵏˡᶦˢᵗᵉᵈ ' : ''}${option.exemptedSEZ ? ' ˢᵉᶻ ' : ''} - ${option.tradeName}`
        }
        else{
            labelText = `${option.gstIN}${option.statusId === 20 ? ' ᵇˡᵃᶜᵏˡᶦˢᵗᵉᵈ ' : ''}${option.exemptedSEZ ? ' ˢᵉᶻ ' : ''}`
        }

        return(
            <>
                <span className="" style={{color: lineItemColor}}>{labelText}</span>
            </>
        )
    }

    const getAddTagsOptions = (tagsConfig, tagOptions, addTagOption) => {
        const addFilterOptions = []
        tagsConfig.map(eachConfig => {
            const optionExists = tagOptions.some(eachOption => {
                if (eachOption.companyTagId === eachConfig.companyTagId) {
                    return true
                }
            })
    
            if (!optionExists) {
                addFilterOptions.push({
                    label: eachConfig.tagLabel,
                    command: () => {
                        addTagOption(eachConfig.companyTagId)
                    }
                })
            }
        })
    
        return addFilterOptions
    }

    const addTagOption = (companyTagId) => {
        let relatedConfig = tagsConfig.find(eachConfig => eachConfig.companyTagId === companyTagId)
        if(relatedConfig && relatedConfig.tagType?.toLowerCase() === "boolean"){
            setTagOptions([...tagOptions, {...relatedConfig, tagValue: false}])
        }else{
            setTagOptions([...tagOptions, relatedConfig])
        }
    }

    const handleRemoveTags = (selectedCompanyTagId) => {
        setSelectedCompanyTagId(selectedCompanyTagId)
        setIsConfirmTagDeleteDialogVisible(true)
    }

    const handleOnChangeTagValue = (event, selectedCompanyTagId) => {
        let updatedTagOptions = tagOptions.map(eachTag => {
            if(eachTag.companyTagId === selectedCompanyTagId){
                return {...eachTag, tagValue: event.target.value}
            }
            return {...eachTag}
        })
        setTagOptions([...updatedTagOptions])
    }

    const handleCloseConfirmTagDeleteDialog = () => {
        setSelectedCompanyTagId(null)
        setIsConfirmTagDeleteDialogVisible(false)
    }

    const handleConfirmDeleteTag = () => {
        const relatedSearchOption = tagOptions.filter(eachOption => eachOption.companyTagId !== selectedCompanyTagId)
        setTagOptions([...relatedSearchOption])
        setSelectedCompanyTagId(null)
        setIsConfirmTagDeleteDialogVisible(false)
    }

    const entityBody = (row) => {
        const relatedBrand = materialBrands.find(eachBrand => eachBrand.brandId === row.entityId.brandId)
        if (relatedBrand) {
            return (
                <div className='flex justify-content-center align-items-center'>
                    <p style={{ cursor: "pointer", padding: "0px", margin: "0px" }}>{relatedBrand.brandName}</p>
                </div>
            )
        }
        return "-"
    }

    const issuedDateBody = (row) => {
        const issuedDateStr = getDateString(row.issuedDate)
        return (
            <div>
                <div className='m-0'>{`${issuedDateStr}`}</div>
            </div>
        )
    }

    const expiryDateBody = (row) => {
        const expiryDateStr = getDateString(row.expiryDate)
        return (
            <div>
                <div className='m-0'>{`${expiryDateStr}`}</div>
            </div>
        )
    }

    const brandCertificateDocProofBody = (row) => {
        if(row.docProof){
            return <FileViewAndRemove doc={{url: row.docProof}} docName="docProof" />
        }
        return "-"
    }

    const handleOnClickEditBrandCertificateBody = (row) => {
        setBrandCertificate({...row})
        setVisibleAddBrandCertificate(true)
    }

    const editBrandCertificateBody = (row) => {
        return (
            <div className="">
                <span className="edit-btn">
                    <Button className="edit-btn-icon p-0" icon="pi pi-user-edit" text onClick={() => handleOnClickEditBrandCertificateBody(row)} size="small" />
                </span>
            </div>
        )
    }

    const deleteBrandCertificateBody = (row) => {
        return (
            <div className="">
                <span className="decrement-btn">
                    <Button className="decrement-btn-icon p-0" icon="pi pi-minus-circle" text onClick={() => handleRemoveBrandCertificate(row.brandCertificateId)} size="small" />
                </span>
            </div>
        )
    }

    const brandCertificatesTableColumns = [
        {
            header: 'Entity',
            field: '',
            body: entityBody,
        },
        {
            header: 'Issued Date',
            field: 'phoneNumber',
            body: issuedDateBody
        },
        {
            header: 'Expirty Date',
            field: 'emailId',
            body: expiryDateBody
        },
        {
            header: 'Brand Certificate',
            field: '',
            body: brandCertificateDocProofBody
        },
        {
            header: 'Edit',
            field: '',
            body: editBrandCertificateBody
        },
        {
            header: 'Delete',
            field: '',
            body: deleteBrandCertificateBody
        }
    ]
    
    const searchBrands = (event) => {
        const relatedBrands = materialBrands.filter(brand => brand.brandName?.toLowerCase().includes(event.query.trim()?.toLowerCase()))
        setSearchedmaterialBrands([...relatedBrands])
    }

    const handleBrandCertificateInputChange = (event) => {
        brandCertificate[event.target.name] = event.target.value
        setBrandCertificate({...brandCertificate})
    }

    const handleRemoveBrandCertificate = (selectedBrandCertificateId) => {
        const relatedBrandCertificates = brandCertificates.filter(eachBrandCertificate => eachBrandCertificate.brandCertificateId !== selectedBrandCertificateId)
        setBrandCertificates([...relatedBrandCertificates])
    }

    const handleRemoveBrandCertificateDoc = () => {
        let updatedBrandCertificate = {...brandCertificate, docProof: null}
        setBrandCertificate(updatedBrandCertificate)
    }

    const handleSubmitBrandCertificate = () => {
        if(!brandCertificate.entityId){
            return dispatch(raiseToast({ severity: 'error', detail: `Please select brand`, life: 3000 }))
        }
        if(!brandCertificate.issuedDate){
            return dispatch(raiseToast({ severity: 'error', detail: `Please select issued date`, life: 3000 }))
        }
        if(!brandCertificate.expiryDate){
            return dispatch(raiseToast({ severity: 'error', detail: `Please select expiry date`, life: 3000 }))
        }
        if(brandCertificate.entityId && brandCertificate.entityId?.config?.certificateProofMandatory && !brandCertificate.docProof){
            return dispatch(raiseToast({ severity: 'error', detail: `Please upload brand certificate`, life: 3000 }))
        }
        
        if(!brandCertificate.remarks || !brandCertificate.remarks?.trim()){
            return dispatch(raiseToast({ severity: 'error', detail: `Please enter remarks`, life: 3000 }))
        }else{
            brandCertificate.remarks = brandCertificate.remarks.trim()
        }

        const duplicateBrandCertificate = brandCertificates.find(eachBrandCertificate => eachBrandCertificate.entityId.brandId === brandCertificate.entityId.brandId && eachBrandCertificate.brandCertificateId !== brandCertificate.brandCertificateId)
        if(duplicateBrandCertificate){
            return dispatch(raiseToast({ severity: 'error', detail: `Brand ${duplicateBrandCertificate.entityId.brandName} is already added.`, life: 3000 }))
        }

        const relatedBrandCertificate = brandCertificates.find(eachBrandCertificate => eachBrandCertificate.brandCertificateId === brandCertificate.brandCertificateId)
        if(relatedBrandCertificate){
            let updatedBrandCertificates = brandCertificates.map(eachBrandCertificate => {
                if(eachBrandCertificate.brandCertificateId === brandCertificate.brandCertificateId){
                    return { ...brandCertificate}
                }
                return {...eachBrandCertificate}
            })
            setBrandCertificates([...updatedBrandCertificates])
        }else{
            setBrandCertificates([...brandCertificates, {...brandCertificate}])
        }

        setBrandCertificate({})
        setVisibleAddBrandCertificate(false)
    }

    const handleAddBrandCertificate = () => {
        setBrandCertificate({
            brandCertificateId: uuidv4(),
            entityType: "Brand",
            entityId: null,
            docProof: null,
            issuedDate: null,
            expiryDate: null,
            remarks: null
        })
        setVisibleAddBrandCertificate(true)
    }

    const handleClosebrandCertificate = () => {
        setBrandCertificate({})
        setVisibleAddBrandCertificate(false)
    }

    const brandCertificateUploadHandler = async ({ files, options }, doc_name) => {
        const { fileArr, error, errorMsg } = await getUploadedFileObj({ files, options, documentName: doc_name })
        if (error) {
            return dispatch(raiseToast({ severity: 'error', detail: errorMsg, life: 3000 }))
        }
        const fileObj = fileArr[0]

        let data = {
            doc_name: "BRAND_CERTIFICATE",
            file_name: fileObj.name,
            data_uri: fileObj.dataURI,
            objectURL: fileObj.inputName
        }
        setIsLoaderVisible(true)
        let response = await uploadFile(data)
        
        setIsLoaderVisible(false)
        if (response) {
            brandCertificate[fileObj.inputName] = response.data
            setBrandCertificate({...brandCertificate})
        }
    }
    
    const addTagOptions = getAddTagsOptions(tagsConfig, tagOptions, addTagOption)
    
    let relatedCountryStates = statesDetails?.filter(eachState => eachState.countryId === companyDetails.countryId)
    let relatedGSTINs = GSTINs?.filter(eachGSTIN => eachGSTIN?.gstIN !== companyDetails?.gstinCode)

    let relatedTDSSections = tdsSections.filter(eachTDS => companyDetails.enableServicePurchase ? ![1].includes(eachTDS.tdsSectionId) : eachTDS.tdsSectionId === 1)

    let tdsApprovalRemarksVisible = false
    let paymentTermsApprovalRemarksVisible = false
    let companyOnboardingApprovalRemarksVisible = false
    
    if([2, 3].includes(companyDetails.buyerSeller)){
        if(companyDetails.enableServicePurchase && companyDetails.tdsSectionId !== 1){
            tdsApprovalRemarksVisible = true
        }
        let relatedCompanyBranchesPaymentTermsApproval = null 
        if (approvals.length){
            relatedCompanyBranchesPaymentTermsApproval = approvals.find(eachApproval => eachApproval.approvalTypeId === 19 && eachApproval.statusId === 1) // APPROVAL_CHANGE find by typeId
        }
        if(relatedCompanyBranchesPaymentTermsApproval){
            if( 
                companyDetails.paymentTerms?.payAdvPO > 0 
                || companyDetails.paymentTerms?.payAdvDelivery > 0 
                || companyDetails.paymentTerms?.payOnDelivery > 0 
                || companyDetails.paymentTerms?.payPDCDelivery > 0
                || (companyDetails.paymentTerms?.payCredit === 100 && companyDetails.paymentTerms?.creditPeriodId < 8)
            ){
                paymentTermsApprovalRemarksVisible = true
            }
        }

        if(!companyDetails.partialOnboarding){
            companyOnboardingApprovalRemarksVisible = true
        }
    }

    let relatedCompanyOwnershipTypes = initialData.companyOwnershipTypesData
    if (!pmCompanyConfig.isInternational){
        if(companyDetails.panCode && companyDetails.gstinCode){
            if(companyDetails.panCode[3] === "F"){
                relatedCompanyOwnershipTypes = initialData.companyOwnershipTypesData?.filter(eachOwnerShipType => [3,4].includes(eachOwnerShipType.ownershipTypeId))
            }else if(companyDetails.panCode[3] === "C"){
                relatedCompanyOwnershipTypes = initialData.companyOwnershipTypesData?.filter(eachOwnerShipType => [6,7].includes(eachOwnerShipType.ownershipTypeId))
            }else{

            }
        }else{
            relatedCompanyOwnershipTypes = initialData.companyOwnershipTypesData?.filter(eachOwnerShipType => [1].includes(eachOwnerShipType.ownershipTypeId))
        }
    }
    
    return (
        <>
            <div className="container company-page relative">
                <Toast ref={toast1}></Toast>
                <div className="company-step-header" style={{ top: 50 }}>
                    <Steps model={items} activeIndex={0} readOnly={true} />
                </div>
                <div className="p-card" style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px"}}>
                    <Toast ref={Toast} />
                    <div className="flex flex-row">
                        <span className=""></span>
                        <h4 className="mt-0 ml-2">Add New Company</h4>
                    </div>
                    <div className="grid mb-2">
                        <div className="flex col-12 mb-1 md:col-4 align-items-center">
                            <label className="text-sm mr-2 ml-3 mt-2 text-600 font-semibold"> Partial Onboarding </label>
                            <InputSwitchField className="mt-2" name="partialOnboarding" checked={partialOnboarding} onChange={(event) => handleToggleSwitchButtonChange(event)} />
                        </div>
                    </div>
                    <div className="grid mx-2">
                        <div className="flex flex-column col-12 md:col-4">
                            <label htmlFor="companyName" style={{fontSize:"12px", marginBottom:"3px"}}>
                                Company Name <span style={{ color: "red" }} className="from-required">*</span>
                                <Tooltip target=".custom-target-icon" position="right" content="Please enter short company name" />
                                <i className="pi pi-info-circle custom-target-icon ml-2"></i>
                            </label>
                            <TextInputField name="companyName" value={companyDetails.companyName} maxLength={100} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.companyName} required />
                        </div>
                        <div className="flex flex-column col-12 md:col-4">
                            <TextInputField name="webpage" labelText="Company Website" value={companyDetails.webpage} maxLength={255} onChange={(event) => handleTextInputChange(event)} />
                        </div>
                        <div className="flex flex-column col-12 md:col-4">
                            <TextInputField name="companyDescription" labelText="Company Description" value={companyDetails.companyDescription} maxLength={300} onChange={(event) => handleTextInputChange(event)} />
                        </div>
                        <div className="flex flex-column col-12 md:col-4">
                            <TextInputField name="companyShortName" labelText="Company Legal Name" value={companyDetails.companyShortName} maxLength={100} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.companyShortName} disabled/>
                        </div>
                        <div className="flex flex-column col-12 md:col-4">
                            <DropDownField name="buyerSeller" labelText="Buyer/Seller" placeholder={"Please Select"} options={initialData.companyTypesData} optionLabel="companyType" optionValue="companyTypeId" value={companyDetails.buyerSeller} showClear onChange={handleTextInputChange} errorMessage={formErrors.buyerSeller} required />
                        </div>
                        {
                            is_buyer || is_buyer_seller ?
                                <>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <label htmlFor="groupId" style={{ fontSize: "12px", marginBottom: "3px" }}>
                                            Company Group <span style={{ color: "red" }} className="from-required">*</span>
                                            <Tooltip target=".company-group-eye-icon" position="right" content="To add a group, please contact tech team offline" />
                                            <i className="pi pi-info-circle company-group-eye-icon ml-2"></i>
                                        </label>
                                        <AutoCompleteField name="groupId" suggestions={relatedCompanyGroupTypes.length === 0 ? initialData?.companyGroupsData : relatedCompanyGroupTypes} field="groupName" value={companyDetails.groupId} onChange={handleTextInputChange} searchMethod={searchCompanyGroupTypes} dropdown forceSelection errorMessage={formErrors.groupId} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <AutoCompleteField name="clientSuccessManagerId" labelText="Client Success Manager" field="fullName" placeholder="Select User" value={companyDetails.clientSuccessManagerId} suggestions={searchedClientSuccessManagers} searchMethod={searchClientSuccessManagers} onChange={handleTextInputChange} dropdown forceSelection errorMessage={formErrors.clientSuccessManagerId} required />
                                    </div>
                                </>
                                : ""
                        }
                    </div>
                    <h5 className="text-600 ml-3 mb-2 my-3">Company Address</h5>
                    <div className="grid mx-2">
                        <div className="flex flex-column col-12 md:col-4">
                            <TextInputField name="address" labelText="Address" value={companyDetails.address} maxLength={300} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.address} required />
                        </div>
                        <div className="flex flex-column col-12 md:col-4">
                            <TextInputField name="city" labelText="City" value={companyDetails.city} maxLength={40} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.city} required />
                        </div>
                        <div className="flex flex-column col-12 md:col-4">
                            <TextInputField name="pinCode" labelText="PinCode" value={companyDetails.pinCode} keyfilter={"pint"} autoComplete={"off"} maxLength={10} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.pinCode} required />
                        </div>
                        {
                            pmCompanyConfig.isInternational ?
                            null
                            :
                            <>
                                <div className="flex flex-column col-12 md:col-4">
                                    <DropDownField name="stateId" labelText="State" options={relatedCountryStates} optionLabel="stateName" optionValue="stateId" value={companyDetails.stateId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.stateId} required disabled /> {/** disabled={pmCompanyConfig.isInternational ? false : true} */}
                                </div>
                                <div className="flex flex-column col-12 md:col-4">
                                    <DropDownField name="countryId" labelText="Country" options={initialData.countryData} optionLabel="countryName" optionValue="countryId" value={companyDetails.countryId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.countryId} required disabled /> {/** disabled={pmCompanyConfig.isInternational ? false : true} */}
                                </div>
                            </>
                        }
                    </div>
                </div>
                {
                    is_buyer_seller || is_seller ?
                        <div className="p-card">
                            <div className="flex">
                                <h5 className="ml-2 mb-2 mt-0">Brand Certificates</h5>
                            </div>
                            {
                                brandCertificates.length ?
                                    <div className="mt-2" style={{ order: "1" }}>
                                        <div className="brand-certificate-table" style={{ backgroundColor: "#edf2f0" }}>
                                            <Table
                                                lazy
                                                tableColumns={brandCertificatesTableColumns}
                                                data={brandCertificates}
                                                scrollable={"true"}
                                                scrollHeight="550px"
                                                style={{ backgroundColor: "#edf2f0", order: "1" }}
                                            />
                                        </div>
                                    </div>
                                    : null
                            }
                            <div className="increment-btn ml-2">
                                <Button className="mt-2" label="Add" outlined onClick={() => handleAddBrandCertificate()} />
                            </div>
                        </div> : null
                }
                <div className="p-card">
                    <div className="flex">
                        <span className=""></span>
                        <h5 className="ml-2 mb-2 mt-0">Other Details</h5>
                    </div>
                    <div className="grid mx-2">
                        <div className="flex col-12 mb-2 md:col-4 lg:mb-0 md:p-0 p-2">
                            <div className="flex flex-column md:col-9 md:py-0">
                                <TextInputField name="panCode" labelText="PAN" value={companyDetails.panCode} maxLength={20} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.panCode} required={ partialOnboarding ? false : true} disabled={pmCompanyConfig.isInternational ? true : false}/>
                            </div>
                            <div className="flex flex-column md:mt-4 md:ml-0 md:col-3 py-0 verify-btn mt-4 ml-2">
                                <Button className="small-btn" onClick={()=> { handleVerifyClick()}} disabled={companyDetails.panCode.length !== 10 || isGSTINDataLoading}>Verify</Button>
                            </div>
                        </div>
                        {
                            pmCompanyConfig.isInternational ? 
                            <div className="flex flex-column col-12 md:col-8 py-0">
                                <TextInputField name="gstinCode" labelText={`Primary ${pmCompanyConfig.GSTINLabel}`} value={companyDetails.gstinCode} maxLength={20} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.gstinCode} {...(isGSTINDataLoading ? { loading: true, disabled: true } : {})} />  {/* ref={gstinDropdownRef} */}
                            </div>
                            :
                            isPANVerified && GSTINs.length > 0 ?
                                <div className="flex flex-column col-12 md:col-8 lg:col-8 py-0">
                                    <DropDownField name="gstinCode" labelText={`Primary ${pmCompanyConfig.GSTINLabel}`} value={companyDetails.gstinCode} options={GSTINs} itemTemplate={companyGSTINOptionTemplate} optionLabel={(eachGSTIN) => eachGSTIN.tradeName ? `${eachGSTIN.gstIN} - ${eachGSTIN.tradeName}` : `${eachGSTIN.gstIN}`} optionValue="gstIN" {...(isGSTINDataLoading ? { loading: true, disabled: true } : {})} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.gstinCode} ref={gstinDropdownRef} />
                                </div>
                                :
                                <div className="flex flex-column col-12 md:col-8 py-0">
                                    <TextInputField name="gstinCode" labelText={`Primary ${pmCompanyConfig.GSTINLabel}`} value={companyDetails.gstinCode} maxLength={35} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.gstinCode} {...(isGSTINDataLoading ? { loading: true, disabled: true } : {})} />  {/* ref={gstinDropdownRef} */}
                                </div>
                        }
                    </div>
                    {
                        is_buyer ?
                            <>  
                                <div className="grid my-2 mx-2">
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="supplyTypeId" labelText="Supply Type" options={initialData.companySupplyTypesData} optionLabel="supplyType" optionValue="supplyTypeId" value={companyDetails.supplyTypeId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.supplyTypeId} required={!partialOnboarding} disabled={pmCompanyConfig.isInternational ? true : false}/>
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="prefPMStateId" labelText="Pref PM State" options={prefPMStateList} optionLabel="stateName" optionValue="stateId" value={companyDetails.prefPMStateId} onChange={(event) => handleTextInputChange(event)} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="prefPMBranchId" labelText="Pref PM Branch" options={prefPMBranches} optionLabel="branchName" optionValue="branchId" value={companyDetails.prefPMBranchId} onChange={(event) => handleTextInputChange(event)} optionDisabled="optionDisabled" errorMessage={formErrors.prefPMBranchId} required />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="prefPMBankId" labelText="Pref PM Bank Details" options={pmCompanyDetails?.companyBankAccounts} optionLabel="bankName" optionValue="bankAccId" value={companyDetails?.prefPMBankId} onChange={(event) => handleTextInputChange(event)} />
                                    </div>
                                </div>
                            </> 
                             :
                            <>
                                <div className="grid my-2 mx-2">
                                    {
                                        is_buyer_seller || companyDetails.buyerSeller === null ?
                                            <div className="flex flex-column col-12 mb-2 md:col-4">
                                                <DropDownField name="supplyTypeId" labelText="Supply Type" options={initialData.companySupplyTypesData} optionLabel="supplyType" optionValue="supplyTypeId" value={companyDetails.supplyTypeId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.supplyTypeId} required={!partialOnboarding} disabled={pmCompanyConfig.isInternational ? true : false}/>
                                            </div> : ""
                                    }
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="ownershipTypeId" labelText="Ownership Type" options={relatedCompanyOwnershipTypes} optionLabel="ownershipType" optionValue="ownershipTypeId" value={companyDetails.ownershipTypeId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.ownershipTypeId} required={!partialOnboarding} disabled={ companyDetails?.panCode[3] === 'P'} /> {/* disabled={ isPANVerified && GSTINs.length === 0} */}
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="sizeId" labelText="Size" options={initialData.companySizeCategoriesData} optionLabel="sizeCategory" optionValue="sizeCategoryId" value={companyDetails.sizeId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.sizeId} required={!partialOnboarding} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="businessTypeId" labelText="Business Type" options={initialData.companyBusinessTypesData} optionLabel="businessType" optionValue="businessTypeId" value={companyDetails.businessTypeId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.businessTypeId} required={!partialOnboarding} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="turnoverCategoryId" labelText="Annual Turnover (In Cr)" options={initialData.companyTurnoverCategoriesData} optionLabel="turnoverCategory" optionValue="turnoverCategoryId" value={companyDetails.turnoverCategoryId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.turnoverCategoryId} required={!partialOnboarding} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="prefPMBankId" labelText="Pref PM Bank Details" options={pmCompanyDetails?.companyBankAccounts} optionLabel="bankName" optionValue="bankAccId" value={companyDetails?.prefPMBankId} onChange={(event) => handleTextInputChange(event)} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="prefPMStateId" labelText="Pref PM State" options={prefPMStateList} optionLabel="stateName" optionValue="stateId" value={companyDetails.prefPMStateId} onChange={(event) => handleTextInputChange(event)} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <DropDownField name="prefPMBranchId" labelText="Pref PM Branch" options={prefPMBranches} optionLabel="branchName" optionValue="branchId" value={companyDetails.prefPMBranchId} onChange={(event) => handleTextInputChange(event)} optionDisabled="optionDisabled" errorMessage={formErrors.prefPMBranchId} required />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-4">
                                        <MultiSelectField name="indicativeIndustryList" labelText="Indicative Industry List" options={materialCategories} optionLabel="categoryName" optionValue="categoryId" value={companyDetails.indicativeIndustryList} onChange={(event) => handleTextInputChange(event)} optionDisabled={(eachCategory) => handleIndustryListOptionDisabled(eachCategory)} />
                                    </div>
                                </div>
                                {
                                    pmCompanyConfig.isInternational ? 
                                    null 
                                    :
                                    <>
                                        <div className="grid mx-2">
                                            <div className="flex col-12 mb-1 md:col-4 align-items-center" style={{}}>
                                                <label className="text-xs mb-1 mr-2"> TDS Section 194Q </label>
                                                <InputSwitchField name="tdsSection194q" checked={tdsSection194q} disabled onChange={(event) => handleToggleSwitchButtonChange(event)} />
                                            </div>
                                        </div>
                                        {
                                            (is_seller || is_buyer_seller) && companyDetails.buyerSeller !== null ?
                                                <div className="grid mb-2 mx-2">
                                                    <Tooltip target=".custom-target-icon" />
                                                    <div className="flex col-12 mb-1 md:col-4 align-items-center" style={{}}>
                                                        <label className="text-xs mb-1 mr-2"> Enable Services Purchase <i className="pi pi-info-circle custom-target-icon" data-pr-tooltip={"Materials can be procure from any onboarded vendor. to purchase services from vendor please enable below"} data-pr-position="bottom" style={{ fontSize: '0.7rem',cursor: 'pointer' }}></i> </label>
                                                        <InputSwitchField name="enableServicePurchase" checked={companyDetails.enableServicePurchase} onChange={(event) => handleToggleSwitchButtonChange(event)} />
                                                    </div>
                                                    {
                                                        companyDetails.enableServicePurchase ?
                                                            <div className="flex col-12 md:col-6">
                                                                <label htmlFor="tdsSectionId" className="col-12 md:col-3 mt-2 pr-0 pl-2" style={{ fontSize: "12px" }}>
                                                                    TDS Section Type {is_seller && companyDetails.enableServicePurchase ? <span style={{ color: "red" }} className="from-required">*</span> : ""}&nbsp;&nbsp; :
                                                                </label>
                                                                <div className="md:col-5pl-0">
                                                                    <DropDownField name="tdsSectionId" labelText="" options={relatedTDSSections} optionLabel={(eachTDS) => `${eachTDS.tdsSectionName} - ${eachTDS.tdsSectionDesc}`} optionValue="tdsSectionId" value={companyDetails.tdsSectionId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.tdsSectionId} required />
                                                                </div>
                                                            </div> : ""
                                                    }
                                                </div> : ""
                                        }
                                    </>
                                }
                                <div className="hr-line" />
                                <Tooltip target=".custom-target-icon" />
                                <h5 className="text-600 mt-3 mb-1 ml-3"> {pmCompanyConfig.MSMEDLabel} <i className="pi pi-info-circle custom-target-icon" data-pr-tooltip={"Not registered :- Please upload pdf or screenshot of the email confirmation from the vendor about MSMED act registration status. \nRegistered :- Please upload pdf or screenshot of MSMED act registration certificate"} data-pr-position="bottom" style={{ fontSize: '0.8rem',cursor: 'pointer' }}></i> { !companyDetails.partialOnboarding ? <span style={{ color: "red" }} className="from-required">*</span> : null}</h5>
                                <div className="flex flex-column mt-2">
                                    <div className="grid flex ml-5">
                                        <div className="flex col-12 md:col-4">
                                            <div className="my-1 flex">
                                                <RadioButton inputId="not-required" name="not-required" value="Not Registered" onChange={(e) => handleMSMEDChange(e)} checked={companyDetails.isMSMEDRegd == 'Not Registered'} disabled={pmCompanyConfig.isInternational ? true : false} />
                                                <label htmlFor="not-required" className="ml-2 text-sm">Not Regd</label>
                                            </div>
                                            <div className="my-1 flex ml-3">
                                                <RadioButton inputId="not-required" name="not-required" value="Registered" onChange={(e) => handleMSMEDChange(e)} checked={companyDetails.isMSMEDRegd == 'Registered'} disabled={pmCompanyConfig.isInternational ? true : false} />
                                                <label htmlFor="not-required" className="ml-2 text-sm">Regd</label>
                                            </div>
                                        </div>
                                        {
                                            companyDetails.isMSMEDRegd == 'Registered' ?
                                                <div className="flex col-12 md:col-4 lg:col-4 mt-0 pt-0">
                                                    <label htmlFor="tdsSectionId" className="col-12 md:col-4 lg:col-4 mt-2 pr-0 pt-0" style={{ fontSize: "12px" }}>
                                                        {pmCompanyConfig.MSMEDLabel} Type {is_seller && companyDetails.isMSMEDRegd == 'Registered' ? <span style={{ color: "red" }} className="from-required">*</span> : ""}&nbsp;&nbsp; :
                                                    </label>
                                                    <div className="md:col-5 lg:col-5 pl-0 pt-0">
                                                        <DropDownField name="companyMSMEDTypeId" labelText="" options={companyMSMEDTypes} optionLabel="companyMSMEDType" optionValue="companyMSMEDTypeId" value={companyDetails.companyMSMEDTypeId} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.companyMSMEDTypeId} required />
                                                    </div>
                                                </div> : ""
                                        }
                                    </div>
                                    <div className="ml-5">
                                        {formErrors.isMSMEDRegd && <small className='p-error' style={{ fontSize: 'x-small'}}>{formErrors.isMSMEDRegd}</small>}
                                    </div>
                                </div>
                            </>
                    }
                    {/* <div className="hr-line" />
                    <h5 className="text-600 mt-3 ml-3"> Tags</h5>
                    <div>
                        {
                            tagOptions.map((eachTag, index) => {
                                let tagPermissions = eachTag.tagConfig && eachTag.tagConfig.permActionId ? [eachTag.tagConfig.permActionId] : []
                                return (
                                    <div className="flex align-items-center m-0 p-0" key={`companyTags-${eachTag.companyTagId}`} style={{ fontSize: "13px" }}>
                                        <div className={`flex flex-column ml-4 mr-2`}>
                                            {index + 1}.
                                        </div>
                                        <div className="flex align-items-center m-0 p-0">
                                            <label className="mr-3" style={{minWidth: "200px"}}>
                                                {eachTag.tagLabel}:
                                            </label>
                                            {
                                                eachTag.tagType?.toLowerCase() === 'integer' ?
                                                    <div className="" style={{width: "200px"}}>
                                                        <TextInputField name="tagValue" labelText="" value={eachTag.tagValue} keyfilter={"pint"} onChange={(event) => handleOnChangeTagValue(event, eachTag.companyTagId)} permissions={tagPermissions} />
                                                    </div> : null
                                            }
                                            {
                                                eachTag.tagType?.toLowerCase() === 'boolean' ?
                                                    <div className="" style={{width: "200px"}}>
                                                        <InputSwitchField name="tagValue" checked={eachTag.tagValue} onChange={(event) => handleOnChangeTagValue(event, eachTag.companyTagId)} permissions={tagPermissions} />
                                                    </div> : null
                                            }
                                            {
                                                eachTag.tagType?.toLowerCase() === 'string' ?
                                                    <div className="" style={{width: "200px"}}>
                                                        <TextInputField name="tagValue" labelText="" value={eachTag.tagValue} onChange={(event) => handleOnChangeTagValue(event, eachTag.companyTagId)} required maxLength={100} permissions={tagPermissions} />
                                                    </div> : null
                                            }
                                            {
                                                eachTag.tagType?.toLowerCase() === 'select' ?
                                                    <div className="" style={{ width: "200px" }}>
                                                        <DropDownField name="tagValue" labelText="" options={eachTag.tagConfig?.options} optionLabel="value" optionValue="value" value={eachTag.tagValue} onChange={(event) => handleOnChangeTagValue(event, eachTag.companyTagId)} permissions={tagPermissions} />
                                                    </div> : null
                                            }
                                            {
                                                eachTag.tagType?.toLowerCase() === 'multiselect' ?
                                                    <div className="" style={{width: "200px"}}>
                                                        <MultiSelectField name="tagValue" labelText="" options={eachTag.tagConfig?.options} optionLabel="value" optionValue="value" value={eachTag.tagValue} onChange={(event) => handleOnChangeTagValue(event, eachTag.companyTagId)} className="multiselect-input-width" permissions={tagPermissions} />
                                                    </div> : null
                                            }
                                        </div>
                                        <div className="flex flex-column col-12 mb-1 md:col-1">
                                            <span className="decrement-btn">
                                                <Button className="decrement-btn-icon" icon="pi pi-minus-circle" text onClick={() => handleRemoveTags(eachTag.companyTagId)} size="medium" />
                                            </span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <div className="increment-btn ml-3">
                            <div className="flex col-12">
                                <Menu model={addTagOptions} popup menuRef={addTagsMenu} id='company-tags' />
                                <Button icon="pi pi-plus-circle" className="small-btn h-2rem p-2 action-btn hover:surface-300 hover:text-700" label="New Tags" onClick={(e) => addTagsMenu.current.toggle(e)} />
                            </div>
                        </div>
                    </div> */}
                    <div className="hr-line" />
                    <h5 className="text-600 mt-3 ml-3">Payment Terms { !companyDetails.partialOnboarding ? <span style={{ color: "red" }} className="from-required">*</span> : null}</h5>
                    <div className="grid p-2 md:ml-3 ml-1">
                        <div className="flex flex-column col-12 md:col-2">
                            <TextInputField name="payAdvPO" labelText="Adv against PO (%)" keyfilter={"pnum"} value={companyDetails?.paymentTerms?.payAdvPO} onChange={(e) => handlePaymentTermsChange(e)} />
                        </div>
                        <div className="flex flex-column col-12 md:col-2">
                            <TextInputField name="payAdvDelivery" labelText="Adv before Delivery (%)" keyfilter={"pnum"} value={companyDetails?.paymentTerms?.payAdvDelivery} onChange={(e) => handlePaymentTermsChange(e)} />
                        </div>
                        <div className="flex flex-column col-12 md:col-2">
                            <TextInputField name="payPDCDelivery" labelText="PDC on Delivery (%)" keyfilter={"pnum"} value={companyDetails?.paymentTerms?.payPDCDelivery} onChange={(e) => handlePaymentTermsChange(e)} />
                        </div>
                        <div className="flex flex-column col-12 md:col-2">
                            <TextInputField name="payOnDelivery" labelText="Pay against Delivery (%)" keyfilter={"pnum"} value={companyDetails?.paymentTerms?.payOnDelivery} onChange={(e) => handlePaymentTermsChange(e)} />
                        </div>
                        <div className="flex flex-column col-12 md:col-1">
                            <TextInputField name="payCredit" labelText="Credit (%)" keyfilter={"pnum"} value={companyDetails?.paymentTerms?.payCredit} onChange={(e) => handlePaymentTermsChange(e)} />
                        </div>
                        {
                            parseInt(companyDetails?.paymentTerms?.payCredit) > 0 || parseInt(companyDetails?.paymentTerms?.payPDCDelivery) > 0 ?
                                <div className="flex flex-column col-12 md:col-2">
                                    <DropDownField name="creditPeriodId" labelText="Credit Period" options={seller_credit_period_terms} optionLabel="creditPeriodName" optionValue="creditPeriodId" value={companyDetails?.paymentTerms?.creditPeriodId} onChange={(e) => handlePaymentTermsChange(e)} />
                                </div> : ""
                        }
                        <div className="flex flex-column col-12 md:col-1 mt-2">
                            <p className={`font-bold text-${total_payment == 100 ? 'green-600' : 'red-500'}`}> {total_payment} </p>
                        </div>
                    </div>                  
                    {(is_seller || is_buyer_seller) && 
                        <>
                            <h5 className="text-600 mt-3 ml-3">Preferred Payment Mode <span style={{ color: "red" }} className="from-required">*</span> </h5>
                            <div className="m-0">
                                <div className="flex flex-column mt-3">
                                    <div className="grid flex ml-5">
                                        <div className="my-1 flex">
                                            <RadioButton inputId="CHEQUE" name="CHEQUE" value="CHEQUE" onChange={handlePreferredPaymentModeChange} checked={companyDetails.preferredPaymentMode === 'CHEQUE'} />
                                            <label htmlFor="CHEQUE" className="ml-2 text-xs">CHEQUE</label>
                                        </div>
                                        <div className="my-1 flex ml-3">
                                            <RadioButton inputId="BANK TRANSFER" name="BANK TRANSFER" value="BANK TRANSFER" onChange={handlePreferredPaymentModeChange} checked={companyDetails.preferredPaymentMode == 'BANK TRANSFER'} />
                                            <label htmlFor="BANK TRANSFER" className="ml-2 text-xs">BANK TRANSFER</label>
                                        </div>
                                    </div>
                                    <div className="ml-5">
                                        {formErrors.preferredPaymentMode && <small className='p-error' style={{ fontSize: 'x-small' }}>{formErrors.preferredPaymentMode}</small>}
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                    {
                        is_buyer ? "" :
                            <>
                                <div className="hr-line" />
                                <div>
                                    <h5 className="text-600 mt-3 mb-3 ml-3">Upload Files</h5>
                                    <div className="grid upload-file ml-3">
                                        <div className="flex align-items-center col-12 mb-2 md:col-4 lg:col-2 lg:mb-0 gstin-certificate">
                                            <label htmlFor="gstCert" className="text-xs mb-1 mr-2">{pmCompanyConfig.GSTINLabel} { !companyDetails.partialOnboarding || companyDetails.gstinCode ? <span style={{ color: "red" }} className="from-required">*</span> : null}: </label>
                                            {
                                                !companyDetails.gstCert ?
                                                    <div>
                                                        <FileUpload mode="basic" name="gstCert" accept="image/pdf/*" customUpload uploadHandler={(files) => fileUploadHandler(files, "GSTIN_CERTIFICATE")} auto chooseLabel="Upload" />
                                                    </div>
                                                    :
                                                    <FileViewAndRemove doc={{url: companyDetails.gstCert}} showRemove handleRemoveDoc={removeCompanyRelatedCertificates} docName="gstCert" />
                                            }
                                        </div>
                                        <div className="flex align-items-center col-12 mb-2 md:col-4  lg:col-2 lg:mb-0">
                                            <label htmlFor="aadharCert" className="text-xs mb-1 mr-2">Aadhar : </label>
                                            {
                                                !companyDetails.aadharCert ?
                                                    <div>
                                                        <FileUpload mode="basic" name="aadharCert" accept="image/pdf/*"  customUpload uploadHandler={(files) => fileUploadHandler(files, "AADHAR_CERTIFICATE")} auto chooseLabel="Upload" disabled={pmCompanyConfig.isInternational ? true : false}/>
                                                    </div>
                                                    :
                                                    <FileViewAndRemove doc={{url: companyDetails.aadharCert}} showRemove handleRemoveDoc={removeCompanyRelatedCertificates} docName="aadharCert" />
                                            }
                                        </div>
                                        <div className="flex align-items-center col-12 md:col-4  lg:col-2 lg:mb-0">
                                            <label htmlFor="panCert" className="text-xs mb-1 mr-2">PAN : </label>
                                            {
                                                !companyDetails.panCert ?
                                                    <div>
                                                        <FileUpload mode="basic" name="panCert" accept="image/pdf/*" customUpload uploadHandler={(files) => fileUploadHandler(files, "PAN_CERTIFICATE")} auto chooseLabel="Upload" disabled={pmCompanyConfig.isInternational ? true : false}/>
                                                    </div>
                                                    :
                                                    <FileViewAndRemove doc={{url: companyDetails.panCert}} showRemove handleRemoveDoc={removeCompanyRelatedCertificates} docName="panCert" />
                                            }
                                        </div>
                                        <div className="flex align-items-center col-12 mb-2 md:col-4  lg:col-3 lg:mb-0">
                                            <label htmlFor="msmedCert" className="text-xs mb-1 mr-2">{pmCompanyConfig.MSMEDLabel} Document { !companyDetails.partialOnboarding ? <span style={{ color: "red" }} className="from-required">*</span> : null} : </label>
                                            {
                                                !companyDetails.msmedCert ?
                                                    <div>
                                                        <FileUpload mode="basic" name="msmedCert" accept="image/pdf/*" customUpload uploadHandler={(files) => fileUploadHandler(files, "MSMED_CERTIFICATE")} auto chooseLabel="Upload" disabled={pmCompanyConfig.isInternational ? true : false}/>
                                                    </div>
                                                    :
                                                    <FileViewAndRemove doc={{url: companyDetails.msmedCert}} showRemove handleRemoveDoc={removeCompanyRelatedCertificates} docName="msmedCert" />
                                            }
                                        </div>
                                        <div className="flex align-items-center col-12 md:col-3">
                                            <label htmlFor="incorporationCert" className="text-xs mb-1 mr-2">Incorporation : </label>
                                            {
                                                !companyDetails.incorporationCert ?
                                                    <div>
                                                        <FileUpload mode="basic" name="incorporationCert" accept="image/pdf/*" customUpload uploadHandler={(files) => fileUploadHandler(files, "INCORPORATION_CERTIFICATE")} auto chooseLabel="Upload" disabled={pmCompanyConfig.isInternational ? true : false}/>
                                                    </div>
                                                    :
                                                    <FileViewAndRemove doc={{url: companyDetails.incorporationCert}} showRemove handleRemoveDoc={removeCompanyRelatedCertificates} docName="incorporationCert" />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </>
                    }
                </div>
                {
                    pmCompanyConfig.isInternational ? 
                    <div className="p-card">
                        <h5 className="text-600 mt-3 mb-2">Billing Address <span style={{ color: "red" }} className="from-required">*</span></h5>
                        <div className="">
                            <div className="increment-btn ml-2">
                                <Button className="increment-btn-icon" icon="pi pi-plus-circle" text size="large" onClick={() => setVisibleAddNewBillingAddr(true)}/>
                            </div>
                            <Dialog header="Add New Billing Address" className='add-new-shipping-address' visible={visibleAddNewBillingAddr} style={{ width: '50vw', minHeight: "35%" }} onHide={() => setVisibleAddNewBillingAddr(false)} >
                                <AddBillingAddress stateList={statesDetails} countriesData={countriesData} handleSubmit={handleSubmitBllAddr} pinCodesData={pinCodesData} />
                            </Dialog>
                        </div>
                            <div className='' style={{ width: "auto" }}>
                            <div className="grid mt-1 flex flex-column shipping-address-container align-items-stretch max-h-27rem">
                                {
                                    companyBillAddrs.length > 0 && 
                                    companyBillAddrs?.map((addr) => {
                                        let relatedState = statesDetails.find(state => state.stateId === parseInt(addr.stateId))
                                        let location = addr.loc ? addr.loc : addr.city
                                        return (
                                            <div key={addr.billAddrId} className="flex flex-column col-12 md:col-5 border-solid border-1 shipping-add-card border-300 border-around-1 m-2 border-round justify-content-between text-xs" style={{ backgroundColor: '#fafafaa3' }}>
                                                <div className='flex p-1 flex-column'>
                                                    <div className=''><span className='text-900 font-medium'>Address:</span> {addr.billAddress} </div>
                                                    <div className=''><span className='text-900 font-medium'>{pmCompanyConfig.GSTINLabel}:</span> {companyDetails.gstinCode} </div>
                                                    <div className=''><span className='text-900 font-medium'>City:</span>{location} </div>
                                                    <div className=''><span className='text-900 font-medium'>State:</span> {relatedState?.stateName} </div>
                                                    {/* <div className=''>Country: {companyData?.country?.countryName}</div> */}
                                                    <div className=''><span className='text-900 font-medium'>Pin:</span> {addr.pinCode} </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    :
                    null
                }
                <div className="p-card">
                    <div className="flex">
                        <h5 className="ml-2 my-0">Add Company User</h5>
                    </div>
                    <div className="grid ml-1 md:ml-3">
                        <div className="flex flex-column col-12 md:col-3">
                            <div className="flex mt-2">
                                <h5 className="text-600 mb-1">Roles</h5>
                                {/*<Button type="button" className='mx-2 my-1' style={{ backgroundColor : 'grey', maxHeight : '4px', maxWidth : '16px'}} icon="pi pi-info" tooltip="Please enter all the Roles" />*/}
                            </div>
                            <div>
                                {companyRoles.map((role, index) => {
                                    return (
                                        <div className="m-2 flex" key={index}>
                                            <span className="mx-2 mt-2">
                                                {index + 1 }
                                            </span>
                                            <TextInputField value={role.roleName} maxLength={255} onChange={(e) => handleCompanyRoleChange(e, role.roleId)} onBlur={(e) => handleCompanyRoleInputBlur(e, role.roleId)} errorMessage={formErrors[`companyRoles[${index}].roleName`]} disabled={role.roleName==="HOD" || role.roleName==="BRANCH HEAD" || role.roleName==="REGIONAL HOD"} />
                                            {
                                                role.roleName!=="HOD" && role.roleName!=="BRANCH HEAD" && role.roleName!=="REGIONAL HOD" ? 
                                                    <span className="decrement-btn ml-2">
                                                        <Button className="decrement-btn-icon" icon="pi pi-minus-circle" text onClick={() => deleteCompanyRole(role.roleId)} size="large"/>
                                                    </span> 
                                                    : ''
                                            }
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="increment-btn">
                                <Button className="increment-btn-icon" icon="pi pi-plus-circle" text onClick={addCompanyRole} size="large"/>
                            </div>
                        </div>
                    </div>
                    <div className="hr-line"/>
                    <div className="md:ml-3">
                        <div className="flex mt-3 ml-2 mb-2">
                            <h5 className="text-600">Users with Company-Wide Access <i className="pi pi-info-circle custom-target-icon" data-pr-tooltip={"Users with access to All Branches"} data-pr-position="bottom" style={{ fontSize: '0.8rem',cursor: 'pointer' }}></i></h5>
                        </div>
                        <div className="grid px-2 ml-1" style={{ marginBottom: "-1.5rem"}}>
                            <div className="flex flex-column mb-2 md:my-5 md:ml-4 ml-2 mt-2">
                                1
                            </div>
                            <div className="flex flex-column col-12 md:col-2">
                                <TextInputField name="hodFirstName" labelText="First Name" value={companyDetails.hodFirstName} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.hodFirstName} required maxLength={100} />
                            </div>
                            <div className="flex flex-column col-12 md:col-2">
                                <TextInputField name="hodLastName" labelText="Last Name" value={companyDetails.hodLastName} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.hodLastName} required maxLength={100}/>
                            </div>
                            <div className="flex flex-column col-12 md:col-1">
                                <DropDownField name="hodISDCode" labelText="ISD Code" options={countriesData} optionLabel="ISDCode" optionValue="ISDCode" value={companyDetails.hodISDCode} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.hodISDCode} required />
                            </div>
                            <div className="flex flex-column col-12 md:col-2">
                                <TextInputField name="hodPhoneNo" labelText="Phone" value={companyDetails.hodPhoneNo} keyfilter={"pint"} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.hodPhoneNo} required maxLength={12} />
                            </div>
                            <div className="flex flex-column col-12 md:col-2">
                                <TextInputField name="hodEmail" labelText="Email" value={companyDetails.hodEmail} onChange={(event) => handleTextInputChange(event)} errorMessage={formErrors.hodEmail} required maxLength={100}/>
                            </div>
                            <div className="flex flex-column col-12 md:col-2">
                                <DropDownField name="hodRole" labelText="Role" options={user_role_list} value={companyDetails.hodRole} onChange={(event) => handleTextInputChange(event)} disabled required />
                            </div>
                        </div>
                        {
                            companyUsers.map((indvUser, index) => {
                                return (
                                    <div className="grid" key={`companyUser-${indvUser.userId}`}>
                                        <div className="flex flex-column mb-2 ml-3 my-3 mt-1">
                                            { index + 2 }
                                        </div>
                                        <div className="flex flex-column col-12 md:col-2">
                                            <TextInputField name="firstName" labelText="" value={indvUser.firstName} onChange={(e) => handleCompanyUsersChange(e, indvUser.userId)} errorMessage={formErrors[`companyUsers[${index}].firstName`]} required maxLength={100} />
                                        </div>
                                        <div className="flex flex-column col-12 md:col-2">
                                            <TextInputField name="lastName" labelText="" value={indvUser.lastName} onChange={(e) => handleCompanyUsersChange(e, indvUser.userId)} errorMessage={formErrors[`companyUsers[${index}].lastName`]} maxLength={100} required />
                                        </div>
                                        <div className="flex flex-column col-12 md:col-1">
                                            <DropDownField name="ISDCode" labelText="" options={countriesData} optionLabel="ISDCode" optionValue="ISDCode" value={indvUser.ISDCode} onChange={(e) => handleCompanyUsersChange(e, indvUser.userId)} errorMessage={formErrors[`companyUsers[${index}].ISDCode`]} required />
                                        </div>
                                        <div className="flex flex-column col-12 md:col-2">
                                            <TextInputField name="phoneNumber" labelText="" value={indvUser.phoneNumber} keyfilter={"pint"} onChange={(e) => handleCompanyUsersChange(e, indvUser.userId)} errorMessage={formErrors[`companyUsers[${index}].phoneNumber`]} maxLength={12} required />
                                        </div>
                                        <div className="flex flex-column col-12 md:col-2">
                                            <TextInputField name="emailId" labelText="" value={indvUser.emailId} onChange={(e) => handleCompanyUsersChange(e, indvUser.userId)} errorMessage={formErrors[`companyUsers[${index}].emailId`]} maxLength={100} required />
                                        </div>
                                        <div className="flex flex-column col-12 md:col-2">
                                            <DropDownField name="companyRoleId" labelText="" options={user_roles_without_hod} value={indvUser.companyRoleId} onChange={(e) => handleCompanyUsersChange(e, indvUser.userId)} errorMessage={formErrors[`companyUsers[${index}].companyRoleId`]} required />
                                        </div>
                                        {
                                            <div className="flex flex-column col-12 mb-1 md:col-1">
                                                <span className="decrement-btn">
                                                    <Button className="decrement-btn-icon" icon="pi pi-minus-circle" text onClick={() => deleteCompanyUser(indvUser.userId)} size="large"/>
                                                </span>
                                            </div>
                                        }
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="increment-btn ml-3">
                        <Button className="increment-btn-icon" icon="pi pi-plus-circle" text onClick={addCompanyUser} size="large" disabled={companyDetails.buyerSeller != 1} />
                    </div>
                </div>
                <div className='mt-3 flex justify-content-center mb-4'>
                    <Button label="Add Company Details" onClick={handleSubmitCompanyDetails} permissions={[25]} />
                </div>  
                <Dialog header={"Approval Remarks"} className='mb-3 approval-remark-dialog' visible={visibleApprovalRemarks} onHide={() => setVisibleApprovalRemarks(false)}>
                    {
                    
                        tdsApprovalRemarksVisible ? 
                            <TextAreaField name="tdsApprovalRemarks" className="mb-3" labelText="Enter remarks for TDS section approval" value={tdsApprovalRemarks} rows={3} onChange={e => setTDSApprovalRemarks(e.target.value)} />
                            : ""
                    }
                    {
                        paymentTermsApprovalRemarksVisible ?
                            <TextAreaField maxLength={400} name="paymentTermsApprovalRemarks" className="mb-3" labelText="Enter remarks for payment terms approval" value={paymentTermsApprovalRemarks} rows={3} onChange={e => setPaymentTermsApprovalRemarks(e.target.value)} />
                            : ""
                    }
                    {
                        companyOnboardingApprovalRemarksVisible ?
                            <TextAreaField maxLength={400} name="companyOnboardingApprovalRemarks" labelText="Enter remarks for company onboarding approval" value={companyOnboardingApprovalRemarks} rows={3} onChange={e => setCompanyOnboardingApprovalRemarks(e.target.value)} />
                            : ""
                    }
                    <div className='flex flex-row justify-content-end'>
                        <Button className="mt-2" label="SUBMIT" outlined onClick={() => addCompany()} />
                    </div>
                </Dialog>
                <Dialog header="Brand Certificate" className='mb-3' visible={visibleAddBrandCertificate} onHide={() => handleClosebrandCertificate()}>
                    <div>
                        <div className="grid" key={`companyUser-${1}`}>
                            <div className="flex flex-column col-12 mb-2 lg:col-5 lg:mb-0">
                                <AutoCompleteField name="entityId" labelText="Brand" field="brandName" placeholder="Search brand" value={brandCertificate.entityId} suggestions={searchedmaterialBrands} searchMethod={searchBrands} onChange={(e) => handleBrandCertificateInputChange(e)} dropdown forceSelection required />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                <CalendarField name="issuedDate" labelText="Issued Date" placeholder="" value={brandCertificate.issuedDate} onChange={(e) => handleBrandCertificateInputChange(e)} required />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                                <CalendarField name="expiryDate" labelText="Expiry Date" placeholder="" value={brandCertificate.expiryDate} onChange={(e) => handleBrandCertificateInputChange(e)} required />
                            </div>
                            <div className="align-items-center col-12 mb-2 md:col-4 lg:col-3 lg:mb-0 gstin-certificate">
                                <label htmlFor="brandCert" className="text-xs mb-1 mr-2">
                                    Brand Certificate 
                                    {brandCertificate.entityId && brandCertificate.entityId.config?.certificateProofMandatory ? <span style={{ color: "red" }} className="from-required">*</span> : null}
                                </label>
                                {
                                    !brandCertificate.docProof ?
                                        <div>
                                            <FileUpload mode="basic" name="docProof" accept="image/pdf/*" customUpload uploadHandler={(files) => brandCertificateUploadHandler(files, "BRAND_CERTIFICATE")} auto chooseLabel="Upload" />
                                        </div>
                                        :
                                        <FileViewAndRemove doc={{ url: brandCertificate.docProof }} showRemove handleRemoveDoc={() => handleRemoveBrandCertificateDoc()} docName="brandCert" />
                                }
                            </div>
                        </div>
                        <TextAreaField name="remarks" className="mb-3" labelText="Enter remarks" value={brandCertificate.remarks} rows={3} onChange={e => handleBrandCertificateInputChange(e)} />
                    </div>
                    <div className="flex justify-content-end mt-2 md:mt-0">
                        <Button label="Submit" className="small-btn" onClick={() => handleSubmitBrandCertificate()} autoFocus applyThrottle={true} />
                    </div>
                </Dialog>
                <SACCode 
                    visibleSACCode={visibleSACCode}
                    setVisibleSACCode={setVisibleSACCode}
                    SACCodesData={SACCodesData}
                    selectedSACCode={selectedSACCode}
                    setSelectedSACCode={setSelectedSACCode}
                />
                <Loading visible={isLoaderVisible} />
                <ConfirmDialog
                    visible={isConfirmTagDeleteDialogVisible}
                    onHide={() => handleCloseConfirmTagDeleteDialog()}
                    message={"Are you sure you want to delete tag?"}
                    header="Confirmation"
                    icon="pi pi-exclamation-triangle"
                    footer={
                        <div>
                            <Button
                                label="No"
                                icon="pi pi-times"
                                onClick={() => handleCloseConfirmTagDeleteDialog()}
                                className="p-button-text"
                                applyThrottle={true}
                            />
                            <Button
                                label="Yes"
                                icon="pi pi-check"
                                onClick={() => handleConfirmDeleteTag()}
                                autoFocus
                                applyThrottle={true}
                            />
                        </div>
                    }
                />
            </div>
        </>
    )
}

export default CompanyAdd;